import React, { FC } from 'react'

import { StyledIcon } from './styled/index'

export type iconName =
  | 'info'
  | 'info-filled'
  | 'delete'
  | 'add'
  | 'search'
  | 'export'
  | 'failed'
  | 'return'
  | 'success'
  | 'waiting'
  | 'add-circle'
  | 'pdf'
  | 'zip'
  | 'maintenance'
  | 'edit-square'
  | 'clear'
  | 'rhuna'
  | 'img-eclipse'
  | 'img-setting'
  | 'basket'
  | 'category'
  | 'color'
  | 'date-check'
  | 'date-outline'
  | 'date'
  | 'key'
  | 'max-number'
  | 'ordinal'
  | 'plug'
  | 'tag-outline'
  | 'tag'
  | 'ticket-rule'
  | 'ticket'
  // Sidebar icons
  | 'sidebar-left'
  | 'home-2'
  | 'star'
  | 'microphone-2'
  | 'textalign-left'
  | 'map'
  | 'play'
  | 'folder-open'
  | 'heart'
  | 'information'
  | 'gallery-edit'
  | 'notification-status'
  | 'ticket-2'
  | 'scan-tickets'
  | 'scan-ticket-profile'
  | 'bag-2'
  | 'profile-2user'
  | 'gift'
  | 'arrow-down'
  | 'setting-3'
  | 'logout'
  | 'warning'
  | 'stages'
  | 'stages-bold'
  | 'news'
  | 'memories'
  | 'notifications'
  | 'wristband'
  | 'chevron-down'
  | 'vouchers'
  | 'plus-circle'
  | 'profile-delete'
  | 'close-circle'
  | 'check'
  | 'Vendor Entity'
  | 'plus-square'
  | 'user-search'
  | 'ticket-customize'
  | 'users'
  | 'calendar-search'
  | 'plus'
  | 'clock'
  | 'arrow-left'
  | 'refresh'
  | 'settings-switches'
  | 'close'
  | 'artists-bold'
  | 'arrow-up-down'
  | 'double-chevron-left'
  | 'chevron-left'
  | 'warning-2'
  | 'calendar-2'
  | 'wallet'
  | 'ticket-3'
  | 'flag-2'
  | 'export-2'
  | 'info-2'
  | 'edit-2'
  | 'refresh-square-2'
  | 'document-text'
  | 'copy'
  | 'loading'
  | 'campaign'
  | 'text'
  | 'flash'
  | 'camera'
  | 'staff'
  | 'import'
  | 'email-preview'
  | 'eye'
  | 'users-filled'
  | 'events-star'
  | 'close-circle-outline'
  | 'online-check-in'
  | 'barcode-check-in'
  | 'transfer-history'
  | 'topup-coin'

const renderIcon = (icon: iconName) => {
  switch (icon) {
    case 'info':
      return (
        <>
          <path d="M10 19.25C7.67936 19.25 5.45376 18.3281 3.81282 16.6872C2.17187 15.0462 1.25 12.8206 1.25 10.5C1.25 8.17936 2.17187 5.95376 3.81282 4.31282C5.45376 2.67187 7.67936 1.75 10 1.75C12.3206 1.75 14.5462 2.67187 16.1872 4.31282C17.8281 5.95376 18.75 8.17936 18.75 10.5C18.75 12.8206 17.8281 15.0462 16.1872 16.6872C14.5462 18.3281 12.3206 19.25 10 19.25ZM10 20.5C12.6522 20.5 15.1957 19.4464 17.0711 17.5711C18.9464 15.6957 20 13.1522 20 10.5C20 7.84784 18.9464 5.3043 17.0711 3.42893C15.1957 1.55357 12.6522 0.5 10 0.5C7.34784 0.5 4.8043 1.55357 2.92893 3.42893C1.05357 5.3043 0 7.84784 0 10.5C0 13.1522 1.05357 15.6957 2.92893 17.5711C4.8043 19.4464 7.34784 20.5 10 20.5Z" />
          <path d="M11.1625 8.735L8.3 9.09375L8.1975 9.56875L8.76 9.6725C9.1275 9.76 9.2 9.8925 9.12 10.2587L8.1975 14.5938C7.955 15.715 8.32875 16.2425 9.2075 16.2425C9.88875 16.2425 10.68 15.9275 11.0388 15.495L11.1487 14.975C10.8987 15.195 10.5337 15.2825 10.2913 15.2825C9.9475 15.2825 9.8225 15.0413 9.91125 14.6163L11.1625 8.735ZM11.25 6.125C11.25 6.45652 11.1183 6.77446 10.8839 7.00888C10.6495 7.2433 10.3315 7.375 10 7.375C9.66848 7.375 9.35054 7.2433 9.11612 7.00888C8.8817 6.77446 8.75 6.45652 8.75 6.125C8.75 5.79348 8.8817 5.47554 9.11612 5.24112C9.35054 5.0067 9.66848 4.875 10 4.875C10.3315 4.875 10.6495 5.0067 10.8839 5.24112C11.1183 5.47554 11.25 5.79348 11.25 6.125Z" />
        </>
      )
    case 'info-filled':
      return (
        <path d="M7.99951 16C10.1212 16 12.1561 15.1571 13.6564 13.6569C15.1567 12.1566 15.9995 10.1217 15.9995 8C15.9995 5.87827 15.1567 3.84344 13.6564 2.34315C12.1561 0.842855 10.1212 0 7.99951 0C5.87778 0 3.84295 0.842855 2.34266 2.34315C0.842367 3.84344 -0.000488281 5.87827 -0.000488281 8C-0.000488281 10.1217 0.842367 12.1566 2.34266 13.6569C3.84295 15.1571 5.87778 16 7.99951 16ZM8.92951 6.588L7.92951 11.293C7.85951 11.633 7.95851 11.826 8.23351 11.826C8.42751 11.826 8.72051 11.756 8.91951 11.58L8.83151 11.996C8.54451 12.342 7.91151 12.594 7.36651 12.594C6.66351 12.594 6.36451 12.172 6.55851 11.275L7.29651 7.807C7.36051 7.514 7.30251 7.408 7.00951 7.337L6.55851 7.256L6.64051 6.875L8.93051 6.588H8.92951ZM7.99951 5.5C7.7343 5.5 7.47994 5.39464 7.29241 5.20711C7.10487 5.01957 6.99951 4.76522 6.99951 4.5C6.99951 4.23478 7.10487 3.98043 7.29241 3.79289C7.47994 3.60536 7.7343 3.5 7.99951 3.5C8.26473 3.5 8.51908 3.60536 8.70662 3.79289C8.89415 3.98043 8.99951 4.23478 8.99951 4.5C8.99951 4.76522 8.89415 5.01957 8.70662 5.20711C8.51908 5.39464 8.26473 5.5 7.99951 5.5Z" />
      )
    case 'delete':
      return (
        <path d="M6.49966 1H9.49966C9.63227 1 9.75945 1.05268 9.85322 1.14645C9.94699 1.24021 9.99966 1.36739 9.99966 1.5V2.5H5.99966V1.5C5.99966 1.36739 6.05234 1.24021 6.14611 1.14645C6.23988 1.05268 6.36706 1 6.49966 1ZM10.9997 2.5V1.5C10.9997 1.10218 10.8416 0.720644 10.5603 0.43934C10.279 0.158035 9.89749 0 9.49966 0H6.49966C6.10184 0 5.72031 0.158035 5.439 0.43934C5.1577 0.720644 4.99966 1.10218 4.99966 1.5V2.5H2.50566C2.50233 2.49997 2.499 2.49997 2.49566 2.5H1.49966C1.36706 2.5 1.23988 2.55268 1.14611 2.64645C1.05234 2.74021 0.999664 2.86739 0.999664 3C0.999664 3.13261 1.05234 3.25979 1.14611 3.35355C1.23988 3.44732 1.36706 3.5 1.49966 3.5H2.03766L2.89066 14.16C2.93089 14.6612 3.15842 15.1289 3.52794 15.4698C3.89746 15.8108 4.38186 16.0001 4.88466 16H11.1147C11.6175 16.0001 12.1019 15.8108 12.4714 15.4698C12.8409 15.1289 13.0684 14.6612 13.1087 14.16L13.9617 3.5H14.4997C14.6323 3.5 14.7594 3.44732 14.8532 3.35355C14.947 3.25979 14.9997 3.13261 14.9997 3C14.9997 2.86739 14.947 2.74021 14.8532 2.64645C14.7594 2.55268 14.6323 2.5 14.4997 2.5H13.5047C13.5013 2.49997 13.498 2.49997 13.4947 2.5H10.9997ZM12.9577 3.5L12.1117 14.08C12.0916 14.3306 11.9778 14.5644 11.793 14.7349C11.6083 14.9054 11.3661 15.0001 11.1147 15H4.88466C4.63326 15.0001 4.39106 14.9054 4.2063 14.7349C4.02154 14.5644 3.90778 14.3306 3.88766 14.08L3.04166 3.5H12.9577ZM5.47066 4.5C5.603 4.49235 5.73295 4.53756 5.83196 4.6257C5.93097 4.71383 5.99093 4.83767 5.99866 4.97L6.49866 13.47C6.50392 13.6008 6.45768 13.7284 6.36988 13.8255C6.28208 13.9225 6.15972 13.9813 6.02907 13.9892C5.89842 13.997 5.7699 13.9533 5.67111 13.8675C5.57231 13.7816 5.51112 13.6605 5.50066 13.53L4.99966 5.03C4.9956 4.96431 5.00455 4.89847 5.02599 4.83625C5.04744 4.77403 5.08095 4.71665 5.12462 4.66741C5.16828 4.61817 5.22124 4.57804 5.28045 4.54931C5.33966 4.52058 5.40396 4.50382 5.46966 4.5H5.47066ZM10.5287 4.5C10.5944 4.50382 10.6587 4.52058 10.7179 4.54931C10.7771 4.57804 10.83 4.61817 10.8737 4.66741C10.9174 4.71665 10.9509 4.77403 10.9723 4.83625C10.9938 4.89847 11.0027 4.96431 10.9987 5.03L10.4987 13.53C10.496 13.5964 10.4801 13.6617 10.4519 13.7219C10.4237 13.7821 10.3838 13.8361 10.3345 13.8807C10.2852 13.9254 10.2274 13.9597 10.1647 13.9817C10.1019 14.0037 10.0354 14.013 9.96906 14.009C9.90268 14.005 9.83777 13.9878 9.77811 13.9585C9.71846 13.9291 9.66527 13.8881 9.62165 13.8379C9.57803 13.7877 9.54487 13.7293 9.52409 13.6661C9.50332 13.603 9.49535 13.5363 9.50066 13.47L10.0007 4.97C10.0084 4.83767 10.0684 4.71383 10.1674 4.6257C10.2664 4.53756 10.3963 4.49235 10.5287 4.5ZM7.99966 4.5C8.13227 4.5 8.25945 4.55268 8.35322 4.64645C8.44699 4.74021 8.49966 4.86739 8.49966 5V13.5C8.49966 13.6326 8.44699 13.7598 8.35322 13.8536C8.25945 13.9473 8.13227 14 7.99966 14C7.86706 14 7.73988 13.9473 7.64611 13.8536C7.55234 13.7598 7.49966 13.6326 7.49966 13.5V5C7.49966 4.86739 7.55234 4.74021 7.64611 4.64645C7.73988 4.55268 7.86706 4.5 7.99966 4.5Z" />
      )
    case 'search':
      return (
        <path d="M13.235 13.9519C13.9612 12.9609 14.2865 11.7323 14.1457 10.5118C14.0049 9.29128 13.4085 8.16893 12.4758 7.36927C11.5431 6.56961 10.3428 6.15163 9.1151 6.19893C7.88741 6.24624 6.72286 6.75534 5.85442 7.6244C4.98598 8.49346 4.47771 9.65838 4.43128 10.8861C4.38485 12.1138 4.8037 13.3138 5.60402 14.246C6.40435 15.1781 7.52713 15.7737 8.74773 15.9136C9.96834 16.0535 11.1968 15.7274 12.1872 15.0004H12.1865C12.209 15.0304 12.233 15.0589 12.26 15.0867L15.1475 17.9742C15.2881 18.1149 15.4789 18.194 15.6778 18.1941C15.8768 18.1941 16.0676 18.1152 16.2083 17.9745C16.3491 17.8339 16.4282 17.6431 16.4282 17.4442C16.4283 17.2452 16.3493 17.0544 16.2087 16.9137L13.3212 14.0262C13.2944 13.999 13.2656 13.974 13.235 13.9512V13.9519ZM13.4285 11.0689C13.4285 11.6106 13.3218 12.147 13.1145 12.6475C12.9072 13.148 12.6033 13.6027 12.2203 13.9857C11.8372 14.3688 11.3825 14.6726 10.882 14.8799C10.3816 15.0872 9.84517 15.1939 9.30347 15.1939C8.76177 15.1939 8.22537 15.0872 7.7249 14.8799C7.22443 14.6726 6.76969 14.3688 6.38665 13.9857C6.00361 13.6027 5.69977 13.148 5.49247 12.6475C5.28517 12.147 5.17847 11.6106 5.17847 11.0689C5.17847 9.97491 5.61307 8.9257 6.38665 8.15211C7.16024 7.37852 8.20945 6.94392 9.30347 6.94392C10.3975 6.94392 11.4467 7.37852 12.2203 8.15211C12.9939 8.9257 13.4285 9.97491 13.4285 11.0689Z" />
      )
    case 'add':
      return (
        <>
          <path d="M13.9996 1C14.2649 1 14.5192 1.10536 14.7068 1.29289C14.8943 1.48043 14.9996 1.73478 14.9996 2V14C14.9996 14.2652 14.8943 14.5196 14.7068 14.7071C14.5192 14.8946 14.2649 15 13.9996 15H1.99965C1.73443 15 1.48008 14.8946 1.29254 14.7071C1.10501 14.5196 0.999649 14.2652 0.999649 14V2C0.999649 1.73478 1.10501 1.48043 1.29254 1.29289C1.48008 1.10536 1.73443 1 1.99965 1H13.9996ZM1.99965 0C1.46922 0 0.960508 0.210714 0.585436 0.585786C0.210363 0.960859 -0.000350952 1.46957 -0.000350952 2V14C-0.000350952 14.5304 0.210363 15.0391 0.585436 15.4142C0.960508 15.7893 1.46922 16 1.99965 16H13.9996C14.5301 16 15.0388 15.7893 15.4139 15.4142C15.7889 15.0391 15.9996 14.5304 15.9996 14V2C15.9996 1.46957 15.7889 0.960859 15.4139 0.585786C15.0388 0.210714 14.5301 0 13.9996 0H1.99965Z" />
          <path d="M7.99965 4C8.13226 4 8.25943 4.05268 8.3532 4.14645C8.44697 4.24021 8.49965 4.36739 8.49965 4.5V7.5H11.4996C11.6323 7.5 11.7594 7.55268 11.8532 7.64645C11.947 7.74021 11.9996 7.86739 11.9996 8C11.9996 8.13261 11.947 8.25979 11.8532 8.35355C11.7594 8.44732 11.6323 8.5 11.4996 8.5H8.49965V11.5C8.49965 11.6326 8.44697 11.7598 8.3532 11.8536C8.25943 11.9473 8.13226 12 7.99965 12C7.86704 12 7.73986 11.9473 7.6461 11.8536C7.55233 11.7598 7.49965 11.6326 7.49965 11.5V8.5H4.49965C4.36704 8.5 4.23986 8.44732 4.1461 8.35355C4.05233 8.25979 3.99965 8.13261 3.99965 8C3.99965 7.86739 4.05233 7.74021 4.1461 7.64645C4.23986 7.55268 4.36704 7.5 4.49965 7.5H7.49965V4.5C7.49965 4.36739 7.55233 4.24021 7.6461 4.14645C7.73986 4.05268 7.86704 4 7.99965 4Z" />
        </>
      )
    case 'add-circle':
      return (
        <>
          <path d="M7.99963 15C6.14312 15 4.36264 14.2625 3.04989 12.9497C1.73713 11.637 0.999634 9.85652 0.999634 8C0.999634 6.14348 1.73713 4.36301 3.04989 3.05025C4.36264 1.7375 6.14312 1 7.99963 1C9.85615 1 11.6366 1.7375 12.9494 3.05025C14.2621 4.36301 14.9996 6.14348 14.9996 8C14.9996 9.85652 14.2621 11.637 12.9494 12.9497C11.6366 14.2625 9.85615 15 7.99963 15ZM7.99963 16C10.1214 16 12.1562 15.1571 13.6565 13.6569C15.1568 12.1566 15.9996 10.1217 15.9996 8C15.9996 5.87827 15.1568 3.84344 13.6565 2.34315C12.1562 0.842855 10.1214 0 7.99963 0C5.8779 0 3.84307 0.842855 2.34278 2.34315C0.842489 3.84344 -0.000366211 5.87827 -0.000366211 8C-0.000366211 10.1217 0.842489 12.1566 2.34278 13.6569C3.84307 15.1571 5.8779 16 7.99963 16Z" />
          <path d="M7.99963 4C8.13224 4 8.25942 4.05268 8.35319 4.14645C8.44696 4.24021 8.49963 4.36739 8.49963 4.5V7.5H11.4996C11.6322 7.5 11.7594 7.55268 11.8532 7.64645C11.947 7.74021 11.9996 7.86739 11.9996 8C11.9996 8.13261 11.947 8.25979 11.8532 8.35355C11.7594 8.44732 11.6322 8.5 11.4996 8.5H8.49963V11.5C8.49963 11.6326 8.44696 11.7598 8.35319 11.8536C8.25942 11.9473 8.13224 12 7.99963 12C7.86703 12 7.73985 11.9473 7.64608 11.8536C7.55231 11.7598 7.49963 11.6326 7.49963 11.5V8.5H4.49963C4.36703 8.5 4.23985 8.44732 4.14608 8.35355C4.05231 8.25979 3.99963 8.13261 3.99963 8C3.99963 7.86739 4.05231 7.74021 4.14608 7.64645C4.23985 7.55268 4.36703 7.5 4.49963 7.5H7.49963V4.5C7.49963 4.36739 7.55231 4.24021 7.64608 4.14645C7.73985 4.05268 7.86703 4 7.99963 4Z" />
        </>
      )
    case 'export':
      return (
        <path d="M14.9998 2C14.9998 1.73478 14.8944 1.48043 14.7069 1.29289C14.5193 1.10536 14.265 1 13.9998 1H1.99976C1.73454 1 1.48019 1.10536 1.29265 1.29289C1.10511 1.48043 0.999756 1.73478 0.999756 2V14C0.999756 14.2652 1.10511 14.5196 1.29265 14.7071C1.48019 14.8946 1.73454 15 1.99976 15H13.9998C14.265 15 14.5193 14.8946 14.7069 14.7071C14.8944 14.5196 14.9998 14.2652 14.9998 14V2ZM-0.000244141 2C-0.000244141 1.46957 0.21047 0.960859 0.585542 0.585786C0.960615 0.210714 1.46932 0 1.99976 0H13.9998C14.5302 0 15.0389 0.210714 15.414 0.585786C15.789 0.960859 15.9998 1.46957 15.9998 2V14C15.9998 14.5304 15.789 15.0391 15.414 15.4142C15.0389 15.7893 14.5302 16 13.9998 16H1.99976C1.46932 16 0.960615 15.7893 0.585542 15.4142C0.21047 15.0391 -0.000244141 14.5304 -0.000244141 14V2ZM4.49976 7.5C4.36715 7.5 4.23997 7.55268 4.1462 7.64645C4.05243 7.74021 3.99976 7.86739 3.99976 8C3.99976 8.13261 4.05243 8.25979 4.1462 8.35355C4.23997 8.44732 4.36715 8.5 4.49976 8.5H10.2928L8.14576 10.646C8.09927 10.6925 8.06239 10.7477 8.03723 10.8084C8.01207 10.8692 7.99912 10.9343 7.99912 11C7.99912 11.0657 8.01207 11.1308 8.03723 11.1916C8.06239 11.2523 8.09927 11.3075 8.14576 11.354C8.19224 11.4005 8.24743 11.4374 8.30817 11.4625C8.36891 11.4877 8.43401 11.5006 8.49976 11.5006C8.5655 11.5006 8.6306 11.4877 8.69134 11.4625C8.75208 11.4374 8.80727 11.4005 8.85376 11.354L11.8538 8.354C11.9003 8.30755 11.9373 8.25238 11.9625 8.19163C11.9877 8.13089 12.0006 8.06577 12.0006 8C12.0006 7.93423 11.9877 7.86911 11.9625 7.80837C11.9373 7.74762 11.9003 7.69245 11.8538 7.646L8.85376 4.646C8.80727 4.59951 8.75208 4.56264 8.69134 4.53748C8.6306 4.51232 8.5655 4.49937 8.49976 4.49937C8.43401 4.49937 8.36891 4.51232 8.30817 4.53748C8.24743 4.56264 8.19224 4.59951 8.14576 4.646C8.09927 4.69249 8.06239 4.74768 8.03723 4.80842C8.01207 4.86916 7.99912 4.93426 7.99912 5C7.99912 5.06574 8.01207 5.13084 8.03723 5.19158C8.06239 5.25232 8.09927 5.30751 8.14576 5.354L10.2928 7.5H4.49976Z" />
      )
    case 'failed':
      return (
        <path
          d="M20.6445 10C20.6445 12.6522 19.591 15.1957 17.7156 17.0711C15.8402 18.9464 13.2967 20 10.6445 20C7.99237 20 5.44883 18.9464 3.57346 17.0711C1.6981 15.1957 0.644531 12.6522 0.644531 10C0.644531 7.34784 1.6981 4.8043 3.57346 2.92893C5.44883 1.05357 7.99237 0 10.6445 0C13.2967 0 15.8402 1.05357 17.7156 2.92893C19.591 4.8043 20.6445 7.34784 20.6445 10ZM7.33703 5.8075C7.21967 5.69014 7.0605 5.62421 6.89453 5.62421C6.72856 5.62421 6.56939 5.69014 6.45203 5.8075C6.33467 5.92486 6.26874 6.08403 6.26874 6.25C6.26874 6.41597 6.33467 6.57514 6.45203 6.6925L9.76078 10L6.45203 13.3075C6.39392 13.3656 6.34783 13.4346 6.31638 13.5105C6.28493 13.5864 6.26874 13.6678 6.26874 13.75C6.26874 13.8322 6.28493 13.9136 6.31638 13.9895C6.34783 14.0654 6.39392 14.1344 6.45203 14.1925C6.56939 14.3099 6.72856 14.3758 6.89453 14.3758C6.97671 14.3758 7.05809 14.3596 7.13401 14.3282C7.20994 14.2967 7.27892 14.2506 7.33703 14.1925L10.6445 10.8837L13.952 14.1925C14.0101 14.2506 14.0791 14.2967 14.1551 14.3282C14.231 14.3596 14.3124 14.3758 14.3945 14.3758C14.4767 14.3758 14.5581 14.3596 14.634 14.3282C14.7099 14.2967 14.7789 14.2506 14.837 14.1925C14.8951 14.1344 14.9412 14.0654 14.9727 13.9895C15.0041 13.9136 15.0203 13.8322 15.0203 13.75C15.0203 13.6678 15.0041 13.5864 14.9727 13.5105C14.9412 13.4346 14.8951 13.3656 14.837 13.3075L11.5283 10L14.837 6.6925C14.8951 6.63439 14.9412 6.5654 14.9727 6.48948C15.0041 6.41356 15.0203 6.33218 15.0203 6.25C15.0203 6.16782 15.0041 6.08644 14.9727 6.01052C14.9412 5.9346 14.8951 5.86561 14.837 5.8075C14.7789 5.74939 14.7099 5.70329 14.634 5.67185C14.5581 5.6404 14.4767 5.62421 14.3945 5.62421C14.3124 5.62421 14.231 5.6404 14.1551 5.67185C14.0791 5.70329 14.0101 5.74939 13.952 5.8075L10.6445 9.11625L7.33703 5.8075Z"
          fill="#DC3545"
        />
      )
    case 'return':
      return (
        <path
          d="M20.6445 17.5C20.6445 18.163 20.3811 18.7989 19.9123 19.2678C19.4435 19.7366 18.8076 20 18.1445 20H3.14453C2.48149 20 1.84561 19.7366 1.37676 19.2678C0.907923 18.7989 0.644531 18.163 0.644531 17.5V2.5C0.644531 1.83696 0.907923 1.20107 1.37676 0.732233C1.84561 0.263392 2.48149 0 3.14453 0L18.1445 0C18.8076 0 19.4435 0.263392 19.9123 0.732233C20.3811 1.20107 20.6445 1.83696 20.6445 2.5V17.5ZM15.0195 9.375H7.77828L10.462 6.6925C10.5794 6.57514 10.6453 6.41597 10.6453 6.25C10.6453 6.08403 10.5794 5.92486 10.462 5.8075C10.3447 5.69014 10.1855 5.62421 10.0195 5.62421C9.85356 5.62421 9.69439 5.69014 9.57703 5.8075L5.82703 9.5575C5.76883 9.61556 5.72265 9.68453 5.69114 9.76046C5.65963 9.83639 5.64341 9.91779 5.64341 10C5.64341 10.0822 5.65963 10.1636 5.69114 10.2395C5.72265 10.3155 5.76883 10.3844 5.82703 10.4425L9.57703 14.1925C9.69439 14.3099 9.85356 14.3758 10.0195 14.3758C10.1855 14.3758 10.3447 14.3099 10.462 14.1925C10.5794 14.0751 10.6453 13.916 10.6453 13.75C10.6453 13.584 10.5794 13.4249 10.462 13.3075L7.77828 10.625H15.0195C15.1853 10.625 15.3443 10.5592 15.4615 10.4419C15.5787 10.3247 15.6445 10.1658 15.6445 10C15.6445 9.83424 15.5787 9.67527 15.4615 9.55806C15.3443 9.44085 15.1853 9.375 15.0195 9.375Z"
          fill="#0DCAF0"
        />
      )
    case 'success':
      return (
        <path
          d="M20.6445 10C20.6445 12.6522 19.591 15.1957 17.7156 17.0711C15.8402 18.9464 13.2967 20 10.6445 20C7.99237 20 5.44883 18.9464 3.57346 17.0711C1.6981 15.1957 0.644531 12.6522 0.644531 10C0.644531 7.34784 1.6981 4.8043 3.57346 2.92893C5.44883 1.05357 7.99237 0 10.6445 0C13.2967 0 15.8402 1.05357 17.7156 2.92893C19.591 4.8043 20.6445 7.34784 20.6445 10ZM15.682 6.2125C15.5927 6.12352 15.4864 6.05347 15.3694 6.00652C15.2525 5.95957 15.1272 5.9367 15.0012 5.93926C14.8752 5.94183 14.7509 5.96979 14.636 6.02146C14.521 6.07313 14.4176 6.14746 14.332 6.24L9.99078 11.7712L7.37453 9.15375C7.19681 8.98815 6.96175 8.898 6.71888 8.90228C6.476 8.90657 6.24427 9.00496 6.0725 9.17672C5.90074 9.34849 5.80235 9.58022 5.79806 9.8231C5.79378 10.066 5.88393 10.301 6.04953 10.4788L9.35703 13.7875C9.44613 13.8764 9.55224 13.9465 9.66901 13.9936C9.78579 14.0406 9.91084 14.0637 10.0367 14.0613C10.1626 14.059 10.2867 14.0313 10.4017 13.98C10.5166 13.9286 10.62 13.8547 10.7058 13.7625L15.6958 7.525C15.8659 7.34812 15.9599 7.11159 15.9575 6.8662C15.9552 6.6208 15.8567 6.3861 15.6833 6.2125H15.682Z"
          fill="#479F76"
        />
      )
    case 'waiting':
      return (
        <path
          d="M20.6445 10C20.6445 12.6522 19.591 15.1957 17.7156 17.0711C15.8402 18.9464 13.2967 20 10.6445 20C7.99237 20 5.44883 18.9464 3.57346 17.0711C1.6981 15.1957 0.644531 12.6522 0.644531 10C0.644531 7.34784 1.6981 4.8043 3.57346 2.92893C5.44883 1.05357 7.99237 0 10.6445 0C13.2967 0 15.8402 1.05357 17.7156 2.92893C19.591 4.8043 20.6445 7.34784 20.6445 10ZM10.6445 4.375C10.6445 4.20924 10.5787 4.05027 10.4615 3.93306C10.3443 3.81585 10.1853 3.75 10.0195 3.75C9.85377 3.75 9.6948 3.81585 9.57759 3.93306C9.46038 4.05027 9.39453 4.20924 9.39453 4.375V11.25C9.39457 11.3602 9.42372 11.4684 9.47904 11.5636C9.53436 11.6589 9.61387 11.7379 9.70953 11.7925L14.0845 14.2925C14.2281 14.3701 14.3963 14.3885 14.5533 14.3437C14.7102 14.2989 14.8434 14.1944 14.9243 14.0527C15.0053 13.9111 15.0276 13.7433 14.9866 13.5854C14.9455 13.4274 14.8443 13.2918 14.7045 13.2075L10.6445 10.8875V4.375Z"
          fill="#FFC107"
        />
      )
    case 'pdf':
      return (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.68664 0H16.7226L26.9235 10.6327V31.3134C26.9235 33.9041 24.8276 36 22.2458 36H4.68664C2.09594 36 7.40333e-10 33.9041 7.40333e-10 31.3134V4.68664C-4.54852e-05 2.09595 2.0959 0 4.68664 0Z"
            fill="#E5252A"
          />
          <path
            opacity="0.302"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.7136 0V10.5517H26.9235L16.7136 0Z"
            fill="white"
          />
          <path
            d="M5.2085 26.8609V20.2852H8.00611C8.69877 20.2852 9.24751 20.4741 9.66129 20.8609C10.0751 21.2387 10.282 21.7514 10.282 22.3901C10.282 23.0288 10.0751 23.5415 9.66129 23.9193C9.24751 24.3062 8.69877 24.4951 8.00611 24.4951H6.89066V26.8609H5.2085ZM6.89066 23.0648H7.8172C8.06906 23.0648 8.26697 23.0108 8.40192 22.8849C8.53684 22.768 8.60884 22.606 8.60884 22.3902C8.60884 22.1743 8.53688 22.0123 8.40192 21.8954C8.26701 21.7695 8.0691 21.7155 7.8172 21.7155H6.89066V23.0648ZM10.9746 26.8609V20.2852H13.3044C13.7632 20.2852 14.195 20.3481 14.5998 20.4831C15.0046 20.618 15.3734 20.8069 15.6972 21.0678C16.0211 21.3196 16.2819 21.6615 16.4709 22.0933C16.6507 22.5251 16.7497 23.0198 16.7497 23.5775C16.7497 24.1263 16.6508 24.621 16.4709 25.0528C16.2819 25.4846 16.0211 25.8264 15.6972 26.0782C15.3734 26.3391 15.0046 26.528 14.5998 26.663C14.195 26.7979 13.7632 26.8609 13.3044 26.8609H10.9746ZM12.6208 25.4306H13.1065C13.3674 25.4306 13.6103 25.4036 13.8352 25.3406C14.051 25.2777 14.258 25.1787 14.4559 25.0438C14.6448 24.9089 14.7977 24.7199 14.9056 24.4681C15.0136 24.2162 15.0676 23.9193 15.0676 23.5775C15.0676 23.2267 15.0136 22.9298 14.9056 22.678C14.7977 22.4261 14.6448 22.2372 14.4559 22.1023C14.258 21.9674 14.0511 21.8684 13.8352 21.8054C13.6103 21.7425 13.3674 21.7155 13.1065 21.7155H12.6208V25.4306ZM17.5953 26.8609V20.2852H22.273V21.7155H19.2775V22.7679H21.6703V24.1892H19.2775V26.8609H17.5953Z"
            fill="white"
          />
        </>
      )
    case 'zip':
      return (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.68123 0H16.7218L26.9253 10.6351V31.3188C26.9253 33.8973 24.8226 36 22.2441 36H4.68123C2.09162 36 0 33.8973 0 31.3188V4.68123C0 2.09162 2.09162 0 4.68123 0Z"
            fill="#FFB11F"
          />
          <path
            opacity="0.302"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.7109 0V10.5466H26.9255L16.7109 0Z"
            fill="white"
          />
          <path
            d="M9.91611 18.7017V16.2448C9.91611 15.9792 9.70583 15.769 9.44023 15.769H8.11223C7.84664 15.769 7.63635 15.9792 7.63635 16.2448V18.7017L6.89489 20.8708C6.68461 21.4794 6.78422 22.1545 7.16048 22.6746C7.52569 23.1948 8.13433 23.5046 8.77623 23.5046C9.41813 23.5046 10.0157 23.1948 10.392 22.6746C10.7682 22.1545 10.8679 21.4794 10.6576 20.8708L9.91611 18.7017ZM9.60626 22.1102C9.23 22.6525 8.32251 22.6525 7.9352 22.1102C7.74707 21.8446 7.69171 21.4905 7.80238 21.1806L8.04586 20.4502H9.49559L9.75013 21.1806C9.84974 21.4905 9.80544 21.8446 9.60626 22.1102ZM5.83252 2.57746V3.92762C5.83252 4.19321 6.0428 4.40349 6.30839 4.40349H8.11227V6.41765H6.30839C6.0428 6.41765 5.83252 6.62793 5.83252 6.89353V7.93379C5.83252 8.19938 6.0428 8.42071 6.30839 8.42071H8.11227V10.4238H6.30839C6.0428 10.4238 5.83252 10.6341 5.83252 10.8997V11.951C5.83252 12.2166 6.0428 12.4268 6.30839 12.4268H8.11227V13.954C8.11227 14.2196 8.33361 14.4299 8.5992 14.4299H11.2442C11.4987 14.4299 11.72 14.2196 11.72 13.954V12.9027C11.72 12.6482 11.4987 12.4268 11.2442 12.4268H9.42923V10.4238H11.2442C11.4987 10.4238 11.72 10.2135 11.72 9.94791V8.89659C11.72 8.631 11.4987 8.42071 11.2442 8.42071H9.42923V6.41765H11.2442C11.4987 6.41765 11.72 6.19632 11.72 5.93073V4.89046C11.72 4.62487 11.4987 4.40354 11.2442 4.40354H9.42923V2.56641C9.42918 2.56641 5.83252 2.57746 5.83252 2.57746Z"
            fill="white"
          />
        </>
      )
    case 'maintenance':
      return <></>
    case 'edit-square':
      return (
        <>
          <path
            d="M12.1425 1.5H5.8575C3.1275 1.5 1.5 3.1275 1.5 5.8575V12.135C1.5 14.8725 3.1275 16.5 5.8575 16.5H12.135C14.865 16.5 16.4925 14.8725 16.4925 12.1425V5.8575C16.5 3.1275 14.8725 1.5 12.1425 1.5ZM8.2125 13.1325C7.995 13.35 7.5825 13.56 7.2825 13.605L5.4375 13.8675C5.37 13.875 5.3025 13.8825 5.235 13.8825C4.9275 13.8825 4.6425 13.7775 4.44 13.575C4.1925 13.3275 4.0875 12.9675 4.1475 12.57L4.41 10.725C4.455 10.4175 4.6575 10.0125 4.8825 9.795L8.2275 6.45C8.2875 6.6075 8.3475 6.765 8.43 6.945C8.505 7.1025 8.5875 7.2675 8.6775 7.4175C8.7525 7.545 8.835 7.665 8.9025 7.755C8.985 7.8825 9.0825 8.0025 9.1425 8.07C9.18 8.1225 9.21 8.16 9.225 8.175C9.4125 8.4 9.63 8.61 9.8175 8.7675C9.87 8.82 9.9 8.85 9.915 8.8575C10.0275 8.9475 10.14 9.0375 10.2375 9.105C10.3575 9.195 10.4775 9.2775 10.605 9.345C10.755 9.435 10.92 9.5175 11.085 9.6C11.2575 9.675 11.415 9.7425 11.5725 9.795L8.2125 13.1325ZM13.0275 8.3175L12.3375 9.015C12.2925 9.06 12.2325 9.0825 12.1725 9.0825C12.15 9.0825 12.12 9.0825 12.105 9.075C10.5825 8.64 9.3675 7.425 8.9325 5.9025C8.91 5.82 8.9325 5.73 8.9925 5.6775L9.69 4.98C10.83 3.84 11.9175 3.8625 13.035 4.98C13.605 5.55 13.8825 6.0975 13.8825 6.6675C13.875 7.2075 13.5975 7.7475 13.0275 8.3175Z"
            fill="currentColor"
          />
        </>
      )
    case 'clear':
      return (
        <>
          <path d="M9 1.5C4.8675 1.5 1.5 4.8675 1.5 9C1.5 13.1325 4.8675 16.5 9 16.5C13.1325 16.5 16.5 13.1325 16.5 9C16.5 4.8675 13.1325 1.5 9 1.5ZM11.52 10.725C11.7375 10.9425 11.7375 11.3025 11.52 11.52C11.4075 11.6325 11.265 11.685 11.1225 11.685C10.98 11.685 10.8375 11.6325 10.725 11.52L9 9.795L7.275 11.52C7.1625 11.6325 7.02 11.685 6.8775 11.685C6.735 11.685 6.5925 11.6325 6.48 11.52C6.2625 11.3025 6.2625 10.9425 6.48 10.725L8.205 9L6.48 7.275C6.2625 7.0575 6.2625 6.6975 6.48 6.48C6.6975 6.2625 7.0575 6.2625 7.275 6.48L9 8.205L10.725 6.48C10.9425 6.2625 11.3025 6.2625 11.52 6.48C11.7375 6.6975 11.7375 7.0575 11.52 7.275L9.795 9L11.52 10.725Z" />
        </>
      )
    case 'rhuna':
      return (
        <>
          <g id="Rhuna">
            <path
              id="Vector"
              d="M109.172 5.85762V12.1857L119.42 22.4333V16.1053L109.172 5.85762ZM108.653 0.521299L122.348 14.2163C122.678 14.4996 122.867 14.9719 122.867 15.3969V36.0811C122.867 37.0255 122.112 37.7811 121.167 37.7811C120.176 37.7811 119.42 37.0255 119.42 36.0811V27.2974L109.172 17.0497V36.0811C109.172 37.0255 108.417 37.7811 107.472 37.7811C106.528 37.7811 105.725 37.0255 105.725 36.0811V1.7019C105.725 1.04076 106.15 0.379626 106.811 0.143506C107.425 -0.139838 108.181 0.00183516 108.653 0.521299Z"
              fill="var(--fill-0, white)"
            />
            <path
              id="Vector_2"
              d="M92.6761 19.6471L82.4757 6.61322V18.4193L92.6761 31.217V19.6471ZM96.0763 1.98526V36.0811C96.0763 37.0728 95.3207 37.7339 94.3762 37.7811C93.8567 37.7811 93.3845 37.545 93.0539 37.12L82.4757 23.8973V36.0811C82.4757 37.0256 81.6729 37.7811 80.7284 37.7811C79.8312 37.7811 79.0284 37.0256 79.0284 36.0811V1.74914C79.0284 0.804658 79.7839 0.00184988 80.7284 0.00184988C81.2479 0.00184988 81.7673 0.23797 82.0979 0.662987L92.6761 14.1219V1.98526C92.6761 1.04078 93.4317 0.285194 94.3762 0.285194C95.3207 0.285194 96.0763 1.04078 96.0763 1.98526Z"
              fill="var(--fill-0, white)"
            />
            <path
              id="Vector_3"
              d="M69.706 1.70192V27.4863C69.706 28.1002 69.3755 28.6197 68.856 28.9502L55.161 37.4978C54.8777 37.6867 54.5943 37.7339 54.2638 37.7811C53.3193 37.8284 52.5165 36.9311 52.5165 36.0811V1.70192C52.5165 0.757434 53.3193 0.00184988 54.2638 0.00184988C55.2082 0.00184988 55.9638 0.757434 55.9638 1.70192V32.9643L66.2587 26.5418V1.70192C66.2587 0.757434 67.0615 0.00184988 68.006 0.00184988C68.9505 0.00184988 69.706 0.757434 69.706 1.70192Z"
              fill="var(--fill-0, white)"
            />
            <path
              id="Vector_4"
              d="M29.1294 12.044V17.1914H39.4242V12.044H29.1294ZM41.1715 0.00184988C42.116 0.00184988 42.8716 0.757434 42.8716 1.70192V36.0811C42.8716 37.0256 42.116 37.7811 41.1715 37.7811C40.1798 37.7811 39.4242 37.0256 39.4242 36.0811V20.5916H29.1294V36.0811C29.1294 37.0256 28.3738 37.7811 27.4293 37.7811C26.4848 37.7811 25.682 37.0256 25.682 36.0811V1.70192C25.682 0.757434 26.4848 0.00184988 27.4293 0.00184988C28.3738 0.00184988 29.1294 0.757434 29.1294 1.70192V8.59664H39.4242V1.70192C39.4242 0.757434 40.1798 0.00184988 41.1715 0.00184988Z"
              fill="var(--fill-0, white)"
            />
            <path
              id="Vector_5"
              d="M12.1838 10.4387L3.44736 4.81899V15.9167L12.1838 10.4387ZM16.2451 11.9498L4.25017 19.4585L16.7173 34.9952C16.9535 35.3258 17.0951 35.7036 17.0951 36.0814C17.0951 37.0258 16.2923 37.7814 15.3951 37.7814C14.8756 37.7814 14.3561 37.5453 14.0256 37.1203L3.44736 23.8503V36.0814C3.44736 37.0258 2.64455 37.7814 1.70007 37.7814C0.80281 37.7814 0 37.0258 0 36.0814V1.65497C0 0.757716 0.80281 0.0021316 1.70007 0.0021316C2.03064 0.0021316 2.36121 0.0965786 2.64455 0.285475L16.2923 9.02194C16.7646 9.3525 17.0951 9.87197 17.0951 10.4387C17.0951 11.0526 16.7646 11.6193 16.2451 11.9498Z"
              fill="var(--fill-0, white)"
            />
          </g>
        </>
      )
    case 'img-eclipse':
      return (
        <>
          <g id="Ellipse 52" filter="url(#filter0_f_518_38736)">
            <circle
              cx="80.3562"
              cy="80.3562"
              r="34.4096"
              fill="url(#paint0_linear_518_38736)"
              fillOpacity="0.27"
            />
          </g>
          <defs>
            <filter
              id="filter0_f_518_38736"
              x="0"
              y="0"
              width="160.712"
              height="160.712"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="22.9733"
                result="effect1_foregroundBlur_518_38736"
              />
            </filter>
            <linearGradient
              id="paint0_linear_518_38736"
              x1="80.3562"
              y1="45.9466"
              x2="80.3562"
              y2="114.766"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#116C17" />
              <stop offset="0.480769" stopColor="#30FF67" />
              <stop offset="0.721154" stop-color="#9DFF00" />
              <stop offset="1" stopColor="white" />
            </linearGradient>
          </defs>
        </>
      )
    case 'img-setting':
      return (
        <>
          <g id="setting-2">
            <path
              id="Vector"
              d="M20.6187 25.7734C23.4656 25.7734 25.7734 23.4656 25.7734 20.6187C25.7734 17.7718 23.4656 15.464 20.6187 15.464C17.7718 15.464 15.464 17.7718 15.464 20.6187C15.464 23.4656 17.7718 25.7734 20.6187 25.7734Z"
              stroke="var(--stroke-0, #06FF48)"
              strokeWidth="2.52212"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              id="Vector_2"
              d="M3.43651 22.1309V19.1068C3.43651 17.3198 4.89701 15.8421 6.70116 15.8421C9.81116 15.8421 11.0827 13.6428 9.51906 10.9452C8.62558 9.39875 9.15823 7.38842 10.7218 6.49493L13.6944 4.79388C15.0518 3.98631 16.8044 4.46742 17.6119 5.82482L17.8009 6.15129C19.3474 8.84891 21.8903 8.84891 23.4539 6.15129L23.6429 5.82482C24.4505 4.46742 26.2031 3.98631 27.5605 4.79388L30.5331 6.49493C32.0967 7.38842 32.6293 9.39875 31.7358 10.9452C30.1722 13.6428 31.4437 15.8421 34.5537 15.8421C36.3407 15.8421 37.8184 17.3026 37.8184 19.1068V22.1309C37.8184 23.9178 36.3579 25.3955 34.5537 25.3955C31.4437 25.3955 30.1722 27.5948 31.7358 30.2925C32.6293 31.8561 32.0967 33.8492 30.5331 34.7427L27.5605 36.4437C26.2031 37.2513 24.4505 36.7702 23.6429 35.4128L23.4539 35.0863C21.9075 32.3887 19.3645 32.3887 17.8009 35.0863L17.6119 35.4128C16.8044 36.7702 15.0518 37.2513 13.6944 36.4437L10.7218 34.7427C9.15823 33.8492 8.62558 31.8389 9.51906 30.2925C11.0827 27.5948 9.81116 25.3955 6.70116 25.3955C4.89701 25.3955 3.43651 23.9178 3.43651 22.1309Z"
              stroke="var(--stroke-0, white)"
              strokeWidth="2.52212"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              id="Vector_3"
              opacity="0"
              d="M41.2376 0H0V41.2376H41.2376V0Z"
              fill="var(--fill-0, white)"
            />
          </g>
        </>
      )
    case 'basket':
      return (
        <path
          d="M7.60943 1.86464C7.71167 1.69397 7.87752 1.57091 8.0705 1.52252C8.26347 1.47414 8.46776 1.5044 8.63843 1.60664C8.8091 1.70888 8.93216 1.87473 8.98054 2.0677C9.02893 2.26068 8.99867 2.46497 8.89643 2.63564L5.07743 9.00014H18.9284L15.1079 2.63564C15.0057 2.46497 14.9754 2.26068 15.0238 2.0677C15.0722 1.87473 15.1953 1.70888 15.3659 1.60664C15.5366 1.5044 15.7409 1.47414 15.9339 1.52252C16.1268 1.57091 16.2927 1.69397 16.3949 1.86464L20.6774 9.00014H23.2529C23.4518 9.00014 23.6426 9.07915 23.7833 9.21981C23.9239 9.36046 24.0029 9.55122 24.0029 9.75014V12.7501C24.0029 12.949 23.9239 13.1398 23.7833 13.2805C23.6426 13.4211 23.4518 13.5001 23.2529 13.5001H22.5029V21.0001C22.5029 21.7958 22.1869 22.5588 21.6242 23.1215C21.0616 23.6841 20.2986 24.0001 19.5029 24.0001H4.50293C3.70728 24.0001 2.94422 23.6841 2.38161 23.1215C1.819 22.5588 1.50293 21.7958 1.50293 21.0001V13.5001H0.75293C0.554017 13.5001 0.363252 13.4211 0.2226 13.2805C0.0819473 13.1398 0.00292969 12.949 0.00292969 12.7501V9.75014C0.00292969 9.55122 0.0819473 9.36046 0.2226 9.21981C0.363252 9.07915 0.554017 9.00014 0.75293 9.00014H3.32843L7.60793 1.86464H7.60943ZM5.25293 15.7501C5.25293 15.5512 5.17391 15.3605 5.03326 15.2198C4.89261 15.0792 4.70184 15.0001 4.50293 15.0001C4.30402 15.0001 4.11325 15.0792 3.9726 15.2198C3.83195 15.3605 3.75293 15.5512 3.75293 15.7501V20.2501C3.75293 20.449 3.83195 20.6398 3.9726 20.7805C4.11325 20.9211 4.30402 21.0001 4.50293 21.0001C4.70184 21.0001 4.89261 20.9211 5.03326 20.7805C5.17391 20.6398 5.25293 20.449 5.25293 20.2501V15.7501ZM9.00293 15.7501C9.00293 15.5512 8.92391 15.3605 8.78326 15.2198C8.64261 15.0792 8.45184 15.0001 8.25293 15.0001C8.05402 15.0001 7.86325 15.0792 7.7226 15.2198C7.58195 15.3605 7.50293 15.5512 7.50293 15.7501V20.2501C7.50293 20.449 7.58195 20.6398 7.7226 20.7805C7.86325 20.9211 8.05402 21.0001 8.25293 21.0001C8.45184 21.0001 8.64261 20.9211 8.78326 20.7805C8.92391 20.6398 9.00293 20.449 9.00293 20.2501V15.7501ZM12.7529 15.7501C12.7529 15.5512 12.6739 15.3605 12.5333 15.2198C12.3926 15.0792 12.2018 15.0001 12.0029 15.0001C11.804 15.0001 11.6133 15.0792 11.4726 15.2198C11.3319 15.3605 11.2529 15.5512 11.2529 15.7501V20.2501C11.2529 20.449 11.3319 20.6398 11.4726 20.7805C11.6133 20.9211 11.804 21.0001 12.0029 21.0001C12.2018 21.0001 12.3926 20.9211 12.5333 20.7805C12.6739 20.6398 12.7529 20.449 12.7529 20.2501V15.7501ZM16.5029 15.7501C16.5029 15.5512 16.4239 15.3605 16.2833 15.2198C16.1426 15.0792 15.9518 15.0001 15.7529 15.0001C15.554 15.0001 15.3633 15.0792 15.2226 15.2198C15.0819 15.3605 15.0029 15.5512 15.0029 15.7501V20.2501C15.0029 20.449 15.0819 20.6398 15.2226 20.7805C15.3633 20.9211 15.554 21.0001 15.7529 21.0001C15.9518 21.0001 16.1426 20.9211 16.2833 20.7805C16.4239 20.6398 16.5029 20.449 16.5029 20.2501V15.7501ZM20.2529 15.7501C20.2529 15.5512 20.1739 15.3605 20.0333 15.2198C19.8926 15.0792 19.7018 15.0001 19.5029 15.0001C19.304 15.0001 19.1133 15.0792 18.9726 15.2198C18.8319 15.3605 18.7529 15.5512 18.7529 15.7501V20.2501C18.7529 20.449 18.8319 20.6398 18.9726 20.7805C19.1133 20.9211 19.304 21.0001 19.5029 21.0001C19.7018 21.0001 19.8926 20.9211 20.0333 20.7805C20.1739 20.6398 20.2529 20.449 20.2529 20.2501V15.7501Z"
          fill="currentColor"
        />
      )
    case 'category':
      return (
        <path
          d="M4.50293 6.75H19.5029C20.2986 6.75 21.0616 7.06607 21.6242 7.62868C22.1869 8.19129 22.5029 8.95435 22.5029 9.75V14.25C22.5029 15.0456 22.1869 15.8087 21.6242 16.3713C21.0616 16.9339 20.2986 17.25 19.5029 17.25H4.50293C3.70728 17.25 2.94422 16.9339 2.38161 16.3713C1.819 15.8087 1.50293 15.0456 1.50293 14.25V9.75C1.50293 8.95435 1.819 8.19129 2.38161 7.62868C2.94422 7.06607 3.70728 6.75 4.50293 6.75ZM4.50293 8.25C4.1051 8.25 3.72357 8.40804 3.44227 8.68934C3.16096 8.97064 3.00293 9.35218 3.00293 9.75V14.25C3.00293 14.6478 3.16096 15.0294 3.44227 15.3107C3.72357 15.592 4.1051 15.75 4.50293 15.75H19.5029C19.9008 15.75 20.2823 15.592 20.5636 15.3107C20.8449 15.0294 21.0029 14.6478 21.0029 14.25V9.75C21.0029 9.35218 20.8449 8.97064 20.5636 8.68934C20.2823 8.40804 19.9008 8.25 19.5029 8.25H4.50293ZM1.50293 3C1.50293 2.80109 1.58195 2.61032 1.7226 2.46967C1.86325 2.32902 2.05402 2.25 2.25293 2.25H21.7529C21.9518 2.25 22.1426 2.32902 22.2833 2.46967C22.4239 2.61032 22.5029 2.80109 22.5029 3C22.5029 3.19891 22.4239 3.38968 22.2833 3.53033C22.1426 3.67098 21.9518 3.75 21.7529 3.75H2.25293C2.05402 3.75 1.86325 3.67098 1.7226 3.53033C1.58195 3.38968 1.50293 3.19891 1.50293 3ZM1.50293 21C1.50293 20.8011 1.58195 20.6103 1.7226 20.4697C1.86325 20.329 2.05402 20.25 2.25293 20.25H21.7529C21.9518 20.25 22.1426 20.329 22.2833 20.4697C22.4239 20.6103 22.5029 20.8011 22.5029 21C22.5029 21.1989 22.4239 21.3897 22.2833 21.5303C22.1426 21.671 21.9518 21.75 21.7529 21.75H2.25293C2.05402 21.75 1.86325 21.671 1.7226 21.5303C1.58195 21.3897 1.50293 21.1989 1.50293 21Z"
          fill="currentColor"
        />
      )
    case 'color':
      return (
        <path
          d="M18.6524 15.105C21.2024 15.8775 24.0029 16.725 24.0029 12C24.0029 9.62663 23.2991 7.30655 21.9806 5.33316C20.662 3.35977 18.7878 1.8217 16.5951 0.913451C14.4024 0.00519939 11.9896 -0.232441 9.66185 0.230582C7.33408 0.693605 5.19588 1.83649 3.51765 3.51472C1.83942 5.19295 0.696534 7.33115 0.233512 9.65892C-0.229511 11.9867 0.00812907 14.3995 0.916381 16.5922C1.82463 18.7849 3.3627 20.6591 5.33609 21.9776C7.30948 23.2962 9.62956 24 12.0029 24C14.9969 24 14.7419 21.744 14.4764 19.38C14.2904 17.7285 14.0984 16.0245 15.0029 15C15.7004 14.2095 17.1329 14.6445 18.6524 15.105ZM12.0029 7.50001C11.7075 7.50001 11.4149 7.44181 11.1419 7.32873C10.8689 7.21566 10.6209 7.04993 10.4119 6.841C10.203 6.63206 10.0373 6.38403 9.92421 6.11104C9.81113 5.83806 9.75294 5.54548 9.75294 5.25001C9.75294 4.95453 9.81113 4.66195 9.92421 4.38897C10.0373 4.11598 10.203 3.86795 10.4119 3.65902C10.6209 3.45008 10.8689 3.28435 11.1419 3.17128C11.4149 3.0582 11.7075 3.00001 12.0029 3.00001C12.5997 3.00001 13.172 3.23706 13.5939 3.65902C14.0159 4.08097 14.2529 4.65327 14.2529 5.25001C14.2529 5.84674 14.0159 6.41904 13.5939 6.841C13.172 7.26295 12.5997 7.50001 12.0029 7.50001ZM18.7529 12C18.1562 12 17.5839 11.763 17.1619 11.341C16.74 10.919 16.5029 10.3467 16.5029 9.75001C16.5029 9.15327 16.74 8.58097 17.1619 8.15902C17.5839 7.73706 18.1562 7.50001 18.7529 7.50001C19.3497 7.50001 19.922 7.73706 20.3439 8.15902C20.7659 8.58097 21.0029 9.15327 21.0029 9.75001C21.0029 10.3467 20.7659 10.919 20.3439 11.341C19.922 11.763 19.3497 12 18.7529 12ZM7.50294 9.75001C7.50294 10.0455 7.44474 10.3381 7.33166 10.611C7.21859 10.884 7.05286 11.1321 6.84393 11.341C6.63499 11.5499 6.38696 11.7157 6.11397 11.8287C5.84099 11.9418 5.54841 12 5.25293 12C4.95746 12 4.66488 11.9418 4.3919 11.8287C4.11891 11.7157 3.87088 11.5499 3.66194 11.341C3.45301 11.1321 3.28728 10.884 3.17421 10.611C3.06113 10.3381 3.00294 10.0455 3.00294 9.75001C3.00294 9.15327 3.23999 8.58097 3.66194 8.15902C4.0839 7.73706 4.6562 7.50001 5.25293 7.50001C5.84967 7.50001 6.42197 7.73706 6.84393 8.15902C7.26588 8.58097 7.50294 9.15327 7.50294 9.75001ZM8.25294 19.5C7.6562 19.5 7.0839 19.263 6.66194 18.841C6.23999 18.419 6.00294 17.8467 6.00294 17.25C6.00294 16.6533 6.23999 16.081 6.66194 15.659C7.0839 15.2371 7.6562 15 8.25294 15C8.84967 15 9.42197 15.2371 9.84393 15.659C10.2659 16.081 10.5029 16.6533 10.5029 17.25C10.5029 17.8467 10.2659 18.419 9.84393 18.841C9.42197 19.263 8.84967 19.5 8.25294 19.5Z"
          fill="currentColor"
        />
      )
    case 'date-check':
      return (
        <path
          d="M5.25293 0C5.45184 0 5.64261 0.0790176 5.78326 0.21967C5.92391 0.360322 6.00293 0.551088 6.00293 0.75V1.5H18.0029V0.75C18.0029 0.551088 18.0819 0.360322 18.2226 0.21967C18.3633 0.0790176 18.554 0 18.7529 0C18.9518 0 19.1426 0.0790176 19.2833 0.21967C19.4239 0.360322 19.5029 0.551088 19.5029 0.75V1.5H21.0029C21.7986 1.5 22.5616 1.81607 23.1242 2.37868C23.6869 2.94129 24.0029 3.70435 24.0029 4.5V21C24.0029 21.7956 23.6869 22.5587 23.1242 23.1213C22.5616 23.6839 21.7986 24 21.0029 24H3.00293C2.20728 24 1.44422 23.6839 0.881609 23.1213C0.319 22.5587 0.00292969 21.7956 0.00292969 21V4.5C0.00292969 3.70435 0.319 2.94129 0.881609 2.37868C1.44422 1.81607 2.20728 1.5 3.00293 1.5H4.50293V0.75C4.50293 0.551088 4.58195 0.360322 4.7226 0.21967C4.86325 0.0790176 5.05402 0 5.25293 0ZM20.1839 4.5H3.82043C3.37043 4.5 3.00293 4.836 3.00293 5.25V6.75C3.00293 7.164 3.36893 7.5 3.82043 7.5H20.1854C20.6354 7.5 21.0029 7.164 21.0029 6.75V5.25C21.0029 4.836 20.6369 4.5 20.1839 4.5ZM16.2839 13.281C16.4248 13.1402 16.5039 12.9492 16.5039 12.75C16.5039 12.5508 16.4248 12.3598 16.2839 12.219C16.1431 12.0782 15.9521 11.9991 15.7529 11.9991C15.5538 11.9991 15.3628 12.0782 15.2219 12.219L11.2529 16.1895L9.53393 14.469C9.4642 14.3993 9.38141 14.344 9.29031 14.3062C9.1992 14.2685 9.10155 14.2491 9.00293 14.2491C8.90431 14.2491 8.80666 14.2685 8.71555 14.3062C8.62444 14.344 8.54166 14.3993 8.47193 14.469C8.4022 14.5387 8.34688 14.6215 8.30914 14.7126C8.27141 14.8037 8.25198 14.9014 8.25198 15C8.25198 15.0986 8.27141 15.1963 8.30914 15.2874C8.34688 15.3785 8.4022 15.4613 8.47193 15.531L10.7219 17.781C10.7916 17.8508 10.8744 17.9063 10.9655 17.9441C11.0566 17.9819 11.1543 18.0013 11.2529 18.0013C11.3516 18.0013 11.4493 17.9819 11.5404 17.9441C11.6315 17.9063 11.7143 17.8508 11.7839 17.781L16.2839 13.281Z"
          fill="currentColor"
        />
      )
    case 'date-outline':
      return (
        <>
          <path
            d="M16.5029 11.25C16.5029 11.0511 16.5819 10.8603 16.7226 10.7197C16.8633 10.579 17.054 10.5 17.2529 10.5H18.7529C18.9518 10.5 19.1426 10.579 19.2833 10.7197C19.4239 10.8603 19.5029 11.0511 19.5029 11.25V12.75C19.5029 12.9489 19.4239 13.1397 19.2833 13.2803C19.1426 13.421 18.9518 13.5 18.7529 13.5H17.2529C17.054 13.5 16.8633 13.421 16.7226 13.2803C16.5819 13.1397 16.5029 12.9489 16.5029 12.75V11.25Z"
            fill="currentColor"
          />
          <path
            d="M5.25293 0C5.45184 0 5.64261 0.0790176 5.78326 0.21967C5.92391 0.360322 6.00293 0.551088 6.00293 0.75V1.5H18.0029V0.75C18.0029 0.551088 18.0819 0.360322 18.2226 0.21967C18.3633 0.0790176 18.554 0 18.7529 0C18.9518 0 19.1426 0.0790176 19.2833 0.21967C19.4239 0.360322 19.5029 0.551088 19.5029 0.75V1.5H21.0029C21.7986 1.5 22.5616 1.81607 23.1242 2.37868C23.6869 2.94129 24.0029 3.70435 24.0029 4.5V21C24.0029 21.7956 23.6869 22.5587 23.1242 23.1213C22.5616 23.6839 21.7986 24 21.0029 24H3.00293C2.20728 24 1.44422 23.6839 0.881609 23.1213C0.319 22.5587 0.00292969 21.7956 0.00292969 21V4.5C0.00292969 3.70435 0.319 2.94129 0.881609 2.37868C1.44422 1.81607 2.20728 1.5 3.00293 1.5H4.50293V0.75C4.50293 0.551088 4.58195 0.360322 4.7226 0.21967C4.86325 0.0790176 5.05402 0 5.25293 0ZM3.00293 3C2.6051 3 2.22357 3.15804 1.94227 3.43934C1.66096 3.72064 1.50293 4.10218 1.50293 4.5V21C1.50293 21.3978 1.66096 21.7794 1.94227 22.0607C2.22357 22.342 2.6051 22.5 3.00293 22.5H21.0029C21.4008 22.5 21.7823 22.342 22.0636 22.0607C22.3449 21.7794 22.5029 21.3978 22.5029 21V4.5C22.5029 4.10218 22.3449 3.72064 22.0636 3.43934C21.7823 3.15804 21.4008 3 21.0029 3H3.00293Z"
            fill="currentColor"
          />
          <path
            d="M3.75293 6C3.75293 5.80109 3.83195 5.61032 3.9726 5.46967C4.11325 5.32902 4.30402 5.25 4.50293 5.25H19.5029C19.7018 5.25 19.8926 5.32902 20.0333 5.46967C20.1739 5.61032 20.2529 5.80109 20.2529 6V7.5C20.2529 7.69891 20.1739 7.88968 20.0333 8.03033C19.8926 8.17098 19.7018 8.25 19.5029 8.25H4.50293C4.30402 8.25 4.11325 8.17098 3.9726 8.03033C3.83195 7.88968 3.75293 7.69891 3.75293 7.5V6Z"
            fill="currentColor"
          />
        </>
      )
    case 'date':
      return (
        <>
          <path
            d="M6.00293 0.75C6.00293 0.551088 5.92391 0.360322 5.78326 0.21967C5.64261 0.0790176 5.45184 0 5.25293 0C5.05402 0 4.86325 0.0790176 4.7226 0.21967C4.58195 0.360322 4.50293 0.551088 4.50293 0.75V1.5H3.00293C2.20728 1.5 1.44422 1.81607 0.881609 2.37868C0.319 2.94129 0.00292969 3.70435 0.00292969 4.5V6H24.0029V4.5C24.0029 3.70435 23.6869 2.94129 23.1242 2.37868C22.5616 1.81607 21.7986 1.5 21.0029 1.5H19.5029V0.75C19.5029 0.551088 19.4239 0.360322 19.2833 0.21967C19.1426 0.0790176 18.9518 0 18.7529 0C18.554 0 18.3633 0.0790176 18.2226 0.21967C18.0819 0.360322 18.0029 0.551088 18.0029 0.75V1.5H6.00293V0.75ZM14.1059 15.369C15.0434 15.369 15.8819 14.643 15.8819 13.599C15.8819 12.351 15.0914 11.754 14.1419 11.754C13.2629 11.754 12.3899 12.3345 12.3899 13.569C12.3899 14.7945 13.2044 15.369 14.1059 15.369Z"
            fill="currentColor"
          />
          <path
            d="M24.0029 21V7.5H0.00292969V21C0.00292969 21.7956 0.319 22.5587 0.881609 23.1213C1.44422 23.6839 2.20728 24 3.00293 24H21.0029C21.7986 24 22.5616 23.6839 23.1242 23.1213C23.6869 22.5587 24.0029 21.7956 24.0029 21ZM14.0069 19.185C12.3419 19.185 11.5229 18.0345 11.4524 17.0745H12.4769C12.5414 17.6295 13.0574 18.3045 14.0534 18.3045C15.3194 18.3045 16.0049 17.0325 16.0109 15.0585H15.9704C15.7409 15.6795 15.0149 16.2435 13.8959 16.2435C12.6179 16.2435 11.3819 15.3285 11.3819 13.5885C11.3819 11.883 12.6884 10.875 14.0774 10.875C15.8354 10.875 17.0069 11.976 17.0069 14.877C17.0069 17.5845 15.8939 19.1835 14.0069 19.1835V19.185ZM9.67193 11.0325V19.0305H8.65793V12.1185H8.63993C8.20493 12.3525 7.31543 12.8985 6.75293 13.284V12.24C7.38419 11.7977 8.04192 11.3945 8.72243 11.0325H9.67193Z"
            fill="currentColor"
          />
        </>
      )
    case 'key':
      return (
        <path
          d="M5.25002 17.25C4.31053 17.2498 3.38831 16.9975 2.57956 16.5194C1.77081 16.0414 1.10516 15.355 0.652051 14.532C0.198943 13.7091 -0.0250208 12.7795 0.00352281 11.8405C0.0320664 10.9014 0.312072 9.98726 0.814329 9.1933C1.31659 8.39934 2.02269 7.75471 2.85899 7.32664C3.69528 6.89857 4.63112 6.70276 5.56888 6.75963C6.50664 6.8165 7.41197 7.12396 8.19041 7.64995C8.96885 8.17593 9.59188 8.90117 9.99452 9.75H21L23.25 12L21 14.25L19.5 12.75L18 14.25L16.5 12.75L15 14.25L13.5 12.75L12 14.25H9.99452C9.56866 15.1478 8.89675 15.9063 8.05688 16.4374C7.21702 16.9684 6.24369 17.2502 5.25002 17.25ZM3.75002 13.5C4.14784 13.5 4.52937 13.342 4.81068 13.0607C5.09198 12.7794 5.25002 12.3978 5.25002 12C5.25002 11.6022 5.09198 11.2206 4.81068 10.9393C4.52937 10.658 4.14784 10.5 3.75002 10.5C3.35219 10.5 2.97066 10.658 2.68936 10.9393C2.40805 11.2206 2.25002 11.6022 2.25002 12C2.25002 12.3978 2.40805 12.7794 2.68936 13.0607C2.97066 13.342 3.35219 13.5 3.75002 13.5Z"
          fill="currentColor"
        />
      )
    case 'max-number':
      return (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.50293 17.2529C7.50293 17.054 7.58195 16.8632 7.7226 16.7226C7.86325 16.5819 8.05402 16.5029 8.25293 16.5029H21.7529C21.9518 16.5029 22.1426 16.5819 22.2833 16.7226C22.4239 16.8632 22.5029 17.054 22.5029 17.2529C22.5029 17.4518 22.4239 17.6426 22.2833 17.7832C22.1426 17.9239 21.9518 18.0029 21.7529 18.0029H8.25293C8.05402 18.0029 7.86325 17.9239 7.7226 17.7832C7.58195 17.6426 7.50293 17.4518 7.50293 17.2529ZM7.50293 11.2529C7.50293 11.054 7.58195 10.8632 7.7226 10.7226C7.86325 10.5819 8.05402 10.5029 8.25293 10.5029H21.7529C21.9518 10.5029 22.1426 10.5819 22.2833 10.7226C22.4239 10.8632 22.5029 11.054 22.5029 11.2529C22.5029 11.4518 22.4239 11.6426 22.2833 11.7832C22.1426 11.9239 21.9518 12.0029 21.7529 12.0029H8.25293C8.05402 12.0029 7.86325 11.9239 7.7226 11.7832C7.58195 11.6426 7.50293 11.4518 7.50293 11.2529ZM7.50293 5.25291C7.50293 5.05399 7.58195 4.86323 7.7226 4.72258C7.86325 4.58192 8.05402 4.50291 8.25293 4.50291H21.7529C21.9518 4.50291 22.1426 4.58192 22.2833 4.72258C22.4239 4.86323 22.5029 5.05399 22.5029 5.25291C22.5029 5.45182 22.4239 5.64258 22.2833 5.78324C22.1426 5.92389 21.9518 6.00291 21.7529 6.00291H8.25293C8.05402 6.00291 7.86325 5.92389 7.7226 5.78324C7.58195 5.64258 7.50293 5.45182 7.50293 5.25291Z"
            fill="currentColor"
          />
          <path
            d="M2.57243 17.8004V17.0894H3.00293C3.32843 17.0894 3.54743 16.8839 3.54743 16.6139C3.54743 16.3364 3.31043 16.1489 3.00593 16.1489C2.67143 16.1489 2.45543 16.3769 2.44643 16.6139H1.56143C1.58543 15.9134 2.12093 15.4334 3.04043 15.4334C3.92243 15.4304 4.47143 15.8699 4.47593 16.4879C4.47877 16.6999 4.40607 16.9059 4.27085 17.0692C4.13563 17.2324 3.94672 17.3422 3.73793 17.3789V17.4284C3.97464 17.4461 4.19544 17.5543 4.35441 17.7306C4.51337 17.9069 4.59826 18.1376 4.59143 18.3749C4.59593 19.1744 3.83843 19.5749 3.01493 19.5749C2.03093 19.5749 1.51493 19.0199 1.50293 18.3839H2.37593C2.38793 18.6509 2.65493 18.8429 3.00893 18.8474C3.38993 18.8474 3.64493 18.6299 3.64193 18.3224C3.63893 18.0299 3.40943 17.8004 3.02093 17.8004H2.57093H2.57243ZM2.56643 10.7519H1.66043V10.6994C1.66043 10.0874 2.10293 9.43341 3.09743 9.43341C3.97193 9.43341 4.53743 9.92241 4.53743 10.5674C4.53743 11.1509 4.15193 11.4929 3.82343 11.8394L3.01793 12.6974V12.7424H4.59893V13.5029H1.71743V12.9104L3.15293 11.4254C3.35993 11.2124 3.59243 10.9694 3.59243 10.6634C3.59243 10.3934 3.37193 10.1834 3.07943 10.1834C3.0119 10.1809 2.94459 10.1923 2.88162 10.2168C2.81866 10.2413 2.76138 10.2785 2.71332 10.326C2.66526 10.3735 2.62744 10.4303 2.60217 10.493C2.57691 10.5557 2.56475 10.6229 2.56643 10.6904V10.7519ZM3.84893 7.50291H2.89643V4.38891H2.84993L1.95293 5.01891V4.16841L2.89643 3.50391H3.84893V7.50291Z"
            fill="currentColor"
          />
        </>
      )
    case 'ordinal':
      return (
        <path
          d="M12.0029 24C15.1855 24 18.2378 22.7357 20.4882 20.4853C22.7386 18.2348 24.0029 15.1826 24.0029 12C24.0029 8.8174 22.7386 5.76516 20.4882 3.51472C18.2378 1.26428 15.1855 0 12.0029 0C8.82033 0 5.76809 1.26428 3.51765 3.51472C1.26721 5.76516 0.00292969 8.8174 0.00292969 12C0.00292969 15.1826 1.26721 18.2348 3.51765 20.4853C5.76809 22.7357 8.82033 24 12.0029 24ZM5.25293 7.5H18.7529C18.9518 7.5 19.1426 7.57902 19.2833 7.71967C19.4239 7.86032 19.5029 8.05109 19.5029 8.25C19.5029 8.44891 19.4239 8.63968 19.2833 8.78033C19.1426 8.92098 18.9518 9 18.7529 9H5.25293C5.05402 9 4.86325 8.92098 4.7226 8.78033C4.58195 8.63968 4.50293 8.44891 4.50293 8.25C4.50293 8.05109 4.58195 7.86032 4.7226 7.71967C4.86325 7.57902 5.05402 7.5 5.25293 7.5ZM7.50293 12.75C7.50293 12.5511 7.58195 12.3603 7.7226 12.2197C7.86325 12.079 8.05402 12 8.25293 12H15.7529C15.9518 12 16.1426 12.079 16.2833 12.2197C16.4239 12.3603 16.5029 12.5511 16.5029 12.75C16.5029 12.9489 16.4239 13.1397 16.2833 13.2803C16.1426 13.421 15.9518 13.5 15.7529 13.5H8.25293C8.05402 13.5 7.86325 13.421 7.7226 13.2803C7.58195 13.1397 7.50293 12.9489 7.50293 12.75ZM10.5029 17.25C10.5029 17.0511 10.5819 16.8603 10.7226 16.7197C10.8633 16.579 11.054 16.5 11.2529 16.5H12.7529C12.9518 16.5 13.1426 16.579 13.2833 16.7197C13.4239 16.8603 13.5029 17.0511 13.5029 17.25C13.5029 17.4489 13.4239 17.6397 13.2833 17.7803C13.1426 17.921 12.9518 18 12.7529 18H11.2529C11.054 18 10.8633 17.921 10.7226 17.7803C10.5819 17.6397 10.5029 17.4489 10.5029 17.25Z"
          fill="currentColor"
        />
      )
    case 'plug':
      return (
        <path
          d="M1.50293 12.0021C1.50321 9.64461 2.29681 7.35584 3.75598 5.50424C5.21514 3.65264 7.25496 2.34595 9.54703 1.79455C11.8391 1.24315 14.25 1.47913 16.3917 2.46448C18.5333 3.44984 20.2811 5.12725 21.3535 7.22663C22.426 9.32602 22.7607 11.7252 22.3039 14.038C21.8471 16.3508 20.6252 18.4425 18.8351 19.9765C17.045 21.5104 14.7907 22.3973 12.4352 22.4944C10.0798 22.5915 7.7602 21.893 5.84993 20.5116C5.59943 20.3301 5.52593 19.9026 5.84693 19.5816L8.54693 16.8816C9.55809 17.6381 10.8081 18.0048 12.0677 17.9144C13.3273 17.824 14.5121 17.2827 15.4049 16.3896L17.5259 14.2671C17.6665 14.1264 17.7455 13.9357 17.7455 13.7368C17.7455 13.5379 17.6665 13.3472 17.5259 13.2066L16.4654 12.1461L18.8039 9.80156C18.8755 9.73228 18.9325 9.64944 18.9716 9.55788C19.0108 9.46632 19.0314 9.36788 19.0321 9.2683C19.0328 9.16872 19.0137 9.06999 18.9758 8.97787C18.938 8.88576 18.8822 8.8021 18.8117 8.73178C18.7412 8.66147 18.6574 8.6059 18.5651 8.56832C18.4729 8.53074 18.3741 8.5119 18.2745 8.5129C18.175 8.51391 18.0766 8.53473 17.9851 8.57416C17.8937 8.61359 17.811 8.67084 17.7419 8.74256L15.4034 11.0856L13.2824 8.96456L15.6224 6.62156C15.6968 6.55304 15.7565 6.47019 15.798 6.378C15.8395 6.28581 15.862 6.18617 15.864 6.08509C15.866 5.984 15.8476 5.88355 15.8098 5.78977C15.772 5.69599 15.7156 5.61082 15.6441 5.53938C15.5725 5.46794 15.4873 5.4117 15.3935 5.37404C15.2996 5.33639 15.1991 5.31809 15.0981 5.32026C14.997 5.32242 14.8974 5.345 14.8052 5.38664C14.7131 5.42828 14.6303 5.48812 14.5619 5.56256L12.2219 7.90256L11.1614 6.84356C11.0208 6.70296 10.8301 6.62397 10.6312 6.62397C10.4323 6.62397 10.2416 6.70296 10.1009 6.84356L7.97993 8.96456C7.08721 9.85729 6.54609 11.0418 6.45573 12.3011C6.36537 13.5604 6.73182 14.81 7.48793 15.8211L4.78793 18.5211C3.91793 19.3911 3.85793 20.9211 4.96943 21.7266C7.1524 23.3058 9.80331 24.1044 12.4953 23.9938C15.1874 23.8833 17.7638 22.87 19.81 21.1171C21.8561 19.3642 23.2528 16.9738 23.7752 14.3306C24.2976 11.6874 23.9153 8.94537 22.6898 6.54589C21.4644 4.14642 19.4671 2.22917 17.0195 1.10282C14.572 -0.0235251 11.8166 -0.293421 9.19695 0.336589C6.57735 0.966599 4.24599 2.45985 2.57823 4.57593C0.910461 6.69201 0.00334556 9.30777 0.00292969 12.0021C0.00292969 12.201 0.0819473 12.3917 0.2226 12.5324C0.363252 12.673 0.554017 12.7521 0.75293 12.7521C0.951842 12.7521 1.14261 12.673 1.28326 12.5324C1.42391 12.3917 1.50293 12.201 1.50293 12.0021Z"
          fill="currentColor"
        />
      )
    case 'tag-outline':
      return (
        <>
          <path
            d="M9.00293 6.75C9.00293 7.34674 8.76588 7.91903 8.34392 8.34099C7.92196 8.76295 7.34967 9 6.75293 9C6.15619 9 5.5839 8.76295 5.16194 8.34099C4.73998 7.91903 4.50293 7.34674 4.50293 6.75C4.50293 6.15326 4.73998 5.58097 5.16194 5.15901C5.5839 4.73705 6.15619 4.5 6.75293 4.5C7.34967 4.5 7.92196 4.73705 8.34392 5.15901C8.76588 5.58097 9.00293 6.15326 9.00293 6.75ZM7.50293 6.75C7.50293 6.55109 7.42391 6.36032 7.28326 6.21967C7.14261 6.07902 6.95184 6 6.75293 6C6.55402 6 6.36325 6.07902 6.2226 6.21967C6.08195 6.36032 6.00293 6.55109 6.00293 6.75C6.00293 6.94891 6.08195 7.13968 6.2226 7.28033C6.36325 7.42098 6.55402 7.5 6.75293 7.5C6.95184 7.5 7.14261 7.42098 7.28326 7.28033C7.42391 7.13968 7.50293 6.94891 7.50293 6.75Z"
            fill="currentColor"
          />
          <path
            d="M3.00293 1.5H9.88193C10.2797 1.50008 10.6612 1.65818 10.9424 1.9395L21.4424 12.4395C21.7236 12.7208 21.8816 13.1023 21.8816 13.5C21.8816 13.8977 21.7236 14.2792 21.4424 14.5605L14.5634 21.4395C14.2821 21.7207 13.9007 21.8787 13.5029 21.8787C13.1052 21.8787 12.7237 21.7207 12.4424 21.4395L1.94243 10.9395C1.66111 10.6583 1.50301 10.2768 1.50293 9.879V3C1.50293 2.60218 1.66096 2.22064 1.94227 1.93934C2.22357 1.65804 2.60511 1.5 3.00293 1.5ZM3.00293 9.879L13.5029 20.379L20.3819 13.5L9.88193 3H3.00293V9.879Z"
            fill="currentColor"
          />
        </>
      )
    case 'tag':
      return (
        <path
          d="M3.00293 1.5C2.60511 1.5 2.22357 1.65804 1.94227 1.93934C1.66096 2.22064 1.50293 2.60218 1.50293 3V9.879C1.50301 10.2768 1.66111 10.6583 1.94243 10.9395L12.4424 21.4395C12.7237 21.7207 13.1052 21.8787 13.5029 21.8787C13.9007 21.8787 14.2821 21.7207 14.5634 21.4395L21.4424 14.5605C21.7236 14.2792 21.8816 13.8977 21.8816 13.5C21.8816 13.1023 21.7236 12.7208 21.4424 12.4395L10.9424 1.9395C10.6612 1.65818 10.2797 1.50008 9.88193 1.5H3.00293ZM9.00293 6.75C9.00293 7.34674 8.76588 7.91903 8.34392 8.34099C7.92196 8.76295 7.34967 9 6.75293 9C6.15619 9 5.5839 8.76295 5.16194 8.34099C4.73998 7.91903 4.50293 7.34674 4.50293 6.75C4.50293 6.15326 4.73998 5.58097 5.16194 5.15901C5.5839 4.73705 6.15619 4.5 6.75293 4.5C7.34967 4.5 7.92196 4.73705 8.34392 5.15901C8.76588 5.58097 9.00293 6.15326 9.00293 6.75Z"
          fill="currentColor"
        />
      )
    case 'ticket-rule':
      return (
        <path
          d="M0.00292969 6.75C0.00292969 6.15326 0.239983 5.58097 0.661939 5.15901C1.0839 4.73705 1.65619 4.5 2.25293 4.5H21.7529C22.3497 4.5 22.922 4.73705 23.3439 5.15901C23.7659 5.58097 24.0029 6.15326 24.0029 6.75V9C24.0029 9.19891 23.9239 9.38968 23.7833 9.53033C23.6426 9.67098 23.4518 9.75 23.2529 9.75C22.6562 9.75 22.0839 9.98705 21.6619 10.409C21.24 10.831 21.0029 11.4033 21.0029 12C21.0029 12.5967 21.24 13.169 21.6619 13.591C22.0839 14.0129 22.6562 14.25 23.2529 14.25C23.4518 14.25 23.6426 14.329 23.7833 14.4697C23.9239 14.6103 24.0029 14.8011 24.0029 15V17.25C24.0029 17.8467 23.7659 18.419 23.3439 18.841C22.922 19.2629 22.3497 19.5 21.7529 19.5H2.25293C1.65619 19.5 1.0839 19.2629 0.661939 18.841C0.239983 18.419 0.00292969 17.8467 0.00292969 17.25V15C0.00292969 14.8011 0.0819473 14.6103 0.2226 14.4697C0.363252 14.329 0.554017 14.25 0.75293 14.25C1.34967 14.25 1.92196 14.0129 2.34392 13.591C2.76588 13.169 3.00293 12.5967 3.00293 12C3.00293 11.4033 2.76588 10.831 2.34392 10.409C1.92196 9.98705 1.34967 9.75 0.75293 9.75C0.554017 9.75 0.363252 9.67098 0.2226 9.53033C0.0819473 9.38968 0.00292969 9.19891 0.00292969 9V6.75ZM6.00293 5.25V6.75H7.50293V5.25H6.00293ZM7.50293 9.75V8.25H6.00293V9.75H7.50293ZM18.0029 9.75V8.25H16.5029V9.75H18.0029ZM16.5029 6.75H18.0029V5.25H16.5029V6.75ZM7.50293 11.25H6.00293V12.75H7.50293V11.25ZM18.0029 12.75V11.25H16.5029V12.75H18.0029ZM7.50293 14.25H6.00293V15.75H7.50293V14.25ZM18.0029 15.75V14.25H16.5029V15.75H18.0029ZM6.00293 17.25V18.75H7.50293V17.25H6.00293ZM16.5029 18.75H18.0029V17.25H16.5029V18.75Z"
          fill="currentColor"
        />
      )
    case 'ticket':
      return (
        <path
          d="M0.00292969 6.75C0.00292969 6.15326 0.239983 5.58097 0.661939 5.15901C1.0839 4.73705 1.65619 4.5 2.25293 4.5H21.7529C22.3497 4.5 22.922 4.73705 23.3439 5.15901C23.7659 5.58097 24.0029 6.15326 24.0029 6.75V9C24.0029 9.19891 23.9239 9.38968 23.7833 9.53033C23.6426 9.67098 23.4518 9.75 23.2529 9.75C22.6562 9.75 22.0839 9.98705 21.6619 10.409C21.24 10.831 21.0029 11.4033 21.0029 12C21.0029 12.5967 21.24 13.169 21.6619 13.591C22.0839 14.0129 22.6562 14.25 23.2529 14.25C23.4518 14.25 23.6426 14.329 23.7833 14.4697C23.9239 14.6103 24.0029 14.8011 24.0029 15V17.25C24.0029 17.8467 23.7659 18.419 23.3439 18.841C22.922 19.2629 22.3497 19.5 21.7529 19.5H2.25293C1.65619 19.5 1.0839 19.2629 0.661939 18.841C0.239983 18.419 0.00292969 17.8467 0.00292969 17.25V15C0.00292969 14.8011 0.0819473 14.6103 0.2226 14.4697C0.363252 14.329 0.554017 14.25 0.75293 14.25C1.34967 14.25 1.92196 14.0129 2.34392 13.591C2.76588 13.169 3.00293 12.5967 3.00293 12C3.00293 11.4033 2.76588 10.831 2.34392 10.409C1.92196 9.98705 1.34967 9.75 0.75293 9.75C0.554017 9.75 0.363252 9.67098 0.2226 9.53033C0.0819473 9.38968 0.00292969 9.19891 0.00292969 9V6.75ZM6.00293 8.25C6.00293 8.44891 6.08195 8.63968 6.2226 8.78033C6.36325 8.92098 6.55402 9 6.75293 9H17.2529C17.4518 9 17.6426 8.92098 17.7833 8.78033C17.9239 8.63968 18.0029 8.44891 18.0029 8.25C18.0029 8.05109 17.9239 7.86032 17.7833 7.71967C17.6426 7.57902 17.4518 7.5 17.2529 7.5H6.75293C6.55402 7.5 6.36325 7.57902 6.2226 7.71967C6.08195 7.86032 6.00293 8.05109 6.00293 8.25ZM6.00293 15.75C6.00293 15.9489 6.08195 16.1397 6.2226 16.2803C6.36325 16.421 6.55402 16.5 6.75293 16.5H17.2529C17.4518 16.5 17.6426 16.421 17.7833 16.2803C17.9239 16.1397 18.0029 15.9489 18.0029 15.75C18.0029 15.5511 17.9239 15.3603 17.7833 15.2197C17.6426 15.079 17.4518 15 17.2529 15H6.75293C6.55402 15 6.36325 15.079 6.2226 15.2197C6.08195 15.3603 6.00293 15.5511 6.00293 15.75ZM6.00293 12C6.00293 12.3978 6.16097 12.7794 6.44227 13.0607C6.72357 13.342 7.1051 13.5 7.50293 13.5H16.5029C16.9008 13.5 17.2823 13.342 17.5636 13.0607C17.8449 12.7794 18.0029 12.3978 18.0029 12C18.0029 11.6022 17.8449 11.2206 17.5636 10.9393C17.2823 10.658 16.9008 10.5 16.5029 10.5H7.50293C7.1051 10.5 6.72357 10.658 6.44227 10.9393C6.16097 11.2206 6.00293 11.6022 6.00293 12Z"
          fill="currentColor"
        />
      )
    // Sidebar icons
    case 'sidebar-left':
      return (
        <>
          <path
            d="M21.97 2H7.97C4.97 2 2.97 4 2.97 7V17C2.97 20 4.97 22 7.97 22H21.97C24.97 22 26.97 20 26.97 17V7C26.97 4 24.97 2 21.97 2Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
          <path
            d="M8.97 2V22"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.97 9.44L12.47 12L8.97 14.56"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
        </>
      )
    case 'home-2':
      return (
        <>
          <path
            d="M6.765 2.13012L2.7225 5.28012C2.0475 5.80512 1.5 6.92262 1.5 7.77012V13.3276C1.5 15.0676 2.9175 16.4926 4.6575 16.4926H13.3425C15.0825 16.4926 16.5 15.0676 16.5 13.3351V7.87512C16.5 6.96762 15.8925 5.80512 15.15 5.28762L10.515 2.04012C9.465 1.30512 7.7775 1.34262 6.765 2.13012Z"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9 13.4927V11.2427"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )
    case 'star':
      return (
        <path
          d="M10.2975 2.63248L11.6175 5.27248C11.7975 5.63998 12.2775 5.99248 12.6825 6.05998L15.075 6.45748C16.605 6.71248 16.965 7.82248 15.8625 8.91748L14.0025 10.7775C13.6875 11.0925 13.515 11.7 13.6125 12.135L14.145 14.4375C14.565 16.26 13.5975 16.965 11.985 16.0125L9.74249 14.685C9.33749 14.445 8.66999 14.445 8.25749 14.685L6.01499 16.0125C4.40999 16.965 3.43499 16.2525 3.85499 14.4375L4.38749 12.135C4.48499 11.7 4.31249 11.0925 3.99749 10.7775L2.13749 8.91748C1.04249 7.82248 1.39499 6.71248 2.92499 6.45748L5.31749 6.05998C5.71499 5.99248 6.19499 5.63998 6.37499 5.27248L7.69499 2.63248C8.41499 1.19998 9.58499 1.19998 10.2975 2.63248Z"
          stroke="currentColor"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )
    case 'microphone-2':
      return (
        <>
          <path
            d="M12 19C15.31 19 18 16.31 18 13V8C18 4.69 15.31 2 12 2C8.69 2 6 4.69 6 8V13C6 16.31 8.69 19 12 19Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
          <path
            d="M3 11V13C3 17.97 7.03 22 12 22C16.97 22 21 17.97 21 13V11"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
          <path
            d="M9.11 7.48C10.89 6.83 12.83 6.83 14.61 7.48"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.03 10.48C11.23 10.15 12.5 10.15 13.7 10.48"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )
    case 'textalign-left':
      return (
        <>
          <path
            d="M3 4.5H21"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3 9.5H12.47"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3 14.5H21"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3 19.5H12.47"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )
    case 'map':
      return (
        <>
          <path
            d="M1.71747 5.83498V13.1325C1.71747 14.5575 2.72997 15.1425 3.95997 14.4375L5.72247 13.4325C6.10497 13.215 6.74247 13.1925 7.13997 13.395L11.0775 15.3675C11.475 15.5625 12.1125 15.5475 12.495 15.33L15.7425 13.47C16.155 13.23 16.5 12.645 16.5 12.165V4.86748C16.5 3.44248 15.4875 2.85748 14.2575 3.56248L12.495 4.56748C12.1125 4.78498 11.475 4.80748 11.0775 4.60498L7.13997 2.63998C6.74247 2.44498 6.10497 2.45998 5.72247 2.67748L2.47497 4.53748C2.05497 4.77748 1.71747 5.36248 1.71747 5.83498Z"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.41998 3V12.75"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.7975 4.96484V14.9998"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )
    case 'play':
      return (
        <path
          d="M3 9.00004V6.33004C3 3.01504 5.3475 1.65754 8.22 3.31504L10.5375 4.65004L12.855 5.98504C15.7275 7.64254 15.7275 10.3575 12.855 12.015L10.5375 13.35L8.22 14.685C5.3475 16.3425 3 14.985 3 11.67V9.00004Z"
          stroke="currentColor"
          strokeWidth="1.125"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )
    case 'folder-open':
      return (
        <>
          <path
            d="M16.2525 10.725L15.9525 14.475C15.84 15.6225 15.75 16.5 13.7175 16.5H4.28251C2.25001 16.5 2.16001 15.6225 2.04751 14.475L1.74751 10.725C1.68751 10.1025 1.88251 9.525 2.23501 9.0825C2.24251 9.075 2.24251 9.075 2.25001 9.0675C2.66251 8.565 3.28501 8.25 3.98251 8.25H14.0175C14.715 8.25 15.33 8.565 15.735 9.0525C15.7425 9.06 15.75 9.0675 15.75 9.075C16.1175 9.5175 16.32 10.095 16.2525 10.725Z"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2.625 8.57246V4.70996C2.625 2.15996 3.2625 1.52246 5.8125 1.52246H6.765C7.7175 1.52246 7.935 1.80746 8.295 2.28746L9.2475 3.56246C9.4875 3.87746 9.63 4.07246 10.2675 4.07246H12.18C14.73 4.07246 15.3675 4.70996 15.3675 7.25996V8.60246"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.07251 12.75H10.9275"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )
    case 'heart':
      return (
        <path
          d="M9.465 15.6077C9.21 15.6977 8.79 15.6977 8.535 15.6077C6.36 14.8652 1.5 11.7677 1.5 6.5177C1.5 4.2002 3.3675 2.3252 5.67 2.3252C7.035 2.3252 8.2425 2.9852 9 4.0052C9.7575 2.9852 10.9725 2.3252 12.33 2.3252C14.6325 2.3252 16.5 4.2002 16.5 6.5177C16.5 11.7677 11.64 14.8652 9.465 15.6077Z"
          stroke="currentColor"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )
    case 'information':
      return (
        <>
          <path
            d="M8.06253 1.83773C8.58753 1.39523 9.43503 1.39523 9.94503 1.83773L11.13 2.85023C11.355 3.03773 11.7825 3.19523 12.0825 3.19523H13.3575C14.1525 3.19523 14.805 3.84773 14.805 4.64273V5.91773C14.805 6.21773 14.9625 6.63773 15.15 6.86273L16.1625 8.04773C16.605 8.57273 16.605 9.42023 16.1625 9.93023L15.15 11.1152C14.9625 11.3402 14.805 11.7602 14.805 12.0602V13.3352C14.805 14.1302 14.1525 14.7827 13.3575 14.7827H12.0825C11.7825 14.7827 11.3625 14.9402 11.1375 15.1277L9.95253 16.1402C9.42753 16.5827 8.58003 16.5827 8.07003 16.1402L6.88503 15.1277C6.66003 14.9402 6.23253 14.7827 5.94003 14.7827H4.62753C3.83253 14.7827 3.18003 14.1302 3.18003 13.3352V12.0527C3.18003 11.7602 3.03003 11.3327 2.84253 11.1152L1.83003 9.92273C1.39503 9.40523 1.39503 8.56523 1.83003 8.04773L2.84253 6.85523C3.03003 6.63023 3.18003 6.21023 3.18003 5.91773V4.65023C3.18003 3.85523 3.83253 3.20273 4.62753 3.20273H5.92503C6.22503 3.20273 6.64503 3.04523 6.87003 2.85773L8.06253 1.83773Z"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9 6.09766V9.72016"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.99585 12H9.00259"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )
    case 'memories':
      return (
        <>
          <path
            d="M6.75 7.5C7.57843 7.5 8.25 6.82843 8.25 6C8.25 5.17157 7.57843 4.5 6.75 4.5C5.92157 4.5 5.25 5.17157 5.25 6C5.25 6.82843 5.92157 7.5 6.75 7.5Z"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.75 1.5H6.75C3 1.5 1.5 3 1.5 6.75V11.25C1.5 15 3 16.5 6.75 16.5H11.25C15 16.5 16.5 15 16.5 11.25V7.5"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.355 1.94249L11.6325 4.66499C11.5275 4.76999 11.4225 4.97249 11.4075 5.12249L11.2575 6.16499C11.205 6.53999 11.4675 6.80249 11.8425 6.74999L12.885 6.59999C13.0275 6.57749 13.2375 6.47999 13.3425 6.37499L16.065 3.65249C16.5375 3.17999 16.755 2.63999 16.065 1.94999C15.3675 1.24499 14.8275 1.46999 14.355 1.94249Z"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.965 2.33252C14.1975 3.15752 14.8425 3.80252 15.6675 4.03502"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2.0025 14.2124L5.7 11.7299C6.2925 11.3324 7.1475 11.3774 7.68 11.8349L7.9275 12.0524C8.5125 12.5549 9.4575 12.5549 10.0425 12.0524L13.1625 9.37492C13.7475 8.87242 14.6925 8.87242 15.2775 9.37492L16.5 10.4249"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )
    case 'gallery-edit':
      return (
        <>
          <path
            d="M22 7.81V13.9L20.37 12.5C19.59 11.83 18.33 11.83 17.55 12.5L13.39 16.07C12.61 16.74 11.35 16.74 10.57 16.07L10.23 15.79C9.52 15.17 8.39 15.11 7.59 15.65L2.67 18.95L2.56 19.03C2.19 18.23 2 17.28 2 16.19V7.81C2 4.17 4.17 2 7.81 2H16.19C19.83 2 22 4.17 22 7.81Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
          <path
            d="M9.09 10.7C10.19 10.7 11.09 9.8 11.09 8.7C11.09 7.6 10.19 6.7 9.09 6.7C7.99 6.7 7.09 7.6 7.09 8.7C7.09 9.8 7.99 10.7 9.09 10.7Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
          <path
            d="M18.34 14.18L14.55 17.97L13.78 20.09C13.6 20.6 14.06 21.06 14.57 20.89L16.69 20.12L20.48 16.33C21.01 15.8 21.26 15.2 20.48 14.42C19.71 13.66 19.11 13.9 18.58 14.43L18.34 14.18Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
          <path
            d="M17.96 14.56C18.24 15.52 18.99 16.27 19.95 16.55"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )
    case 'notification-status':
      return (
        <>
          <path
            d="M12.02 2.91C8.71 2.91 6.02 5.6 6.02 8.91V11.8C6.02 12.41 5.76 13.34 5.45 13.86L4.3 15.77C3.59 16.95 4.08 18.26 5.38 18.7C9.69 20.14 14.34 20.14 18.65 18.7C19.86 18.3 20.39 16.87 19.73 15.77L18.58 13.86C18.28 13.34 18.02 12.41 18.02 11.8V8.91C18.02 5.61 15.32 2.91 12.02 2.91Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            fill="none"
          />
          <path
            d="M13.87 3.2C13.56 3.11 13.24 3.04 12.91 3C11.95 2.88 11.03 2.95 10.17 3.2C10.46 2.46 11.18 1.94 12.02 1.94C12.86 1.94 13.58 2.46 13.87 3.2Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
          <path
            d="M15.02 19.06C15.02 20.71 13.67 22.06 12.02 22.06C11.2 22.06 10.44 21.72 9.9 21.18C9.36 20.64 9.02 19.88 9.02 19.06"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            fill="none"
          />
          <path
            d="M19 8C20.6569 8 22 6.65685 22 5C22 3.34315 20.6569 2 19 2C17.3431 2 16 3.34315 16 5C16 6.65685 17.3431 8 19 8Z"
            fill="#06FF48"
          />
        </>
      )
    case 'ticket-2':
      return (
        <>
          <path
            d="M14.1825 11.0195C14.1825 11.987 14.9775 12.7745 15.945 12.7745C15.945 15.587 15.24 16.292 12.4275 16.292H5.3925C2.58 16.292 1.875 15.587 1.875 12.7745V12.4295C2.8425 12.4295 3.6375 11.6345 3.6375 10.667C3.6375 9.69949 2.8425 8.90449 1.875 8.90449V8.55949C1.8825 5.74699 2.58 5.04199 5.3925 5.04199H12.42C15.2325 5.04199 15.9375 5.74699 15.9375 8.55949V9.26449C14.97 9.26449 14.1825 10.0445 14.1825 11.0195Z"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.1583 5.04187H5.34082L7.53832 2.84438C9.33082 1.05187 10.2308 1.05187 12.0233 2.84438L12.4733 3.29437C12.0008 3.76687 11.8883 4.46437 12.1583 5.04187Z"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.40918 5.04199L7.40918 16.292"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="3.75 3.75"
          />
        </>
      )
    case 'scan-tickets':
      return (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.25 1.3125H12.75C13.9541 1.3125 14.9321 1.71534 15.6084 2.3916C16.2847 3.06786 16.6875 4.0459 16.6875 5.25V6.75C16.6875 6.85039 16.6004 6.9375 16.5 6.9375C16.3996 6.9375 16.3125 6.85039 16.3125 6.75V5.25C16.3125 4.20008 15.9715 3.30156 15.335 2.66504C14.6984 2.02852 13.7999 1.6875 12.75 1.6875H5.25C4.20008 1.6875 3.30156 2.02852 2.66504 2.66504C2.02852 3.30156 1.6875 4.20008 1.6875 5.25V6.75C1.6875 6.85039 1.60039 6.9375 1.5 6.9375C1.39961 6.9375 1.3125 6.85039 1.3125 6.75V5.25C1.3125 4.0459 1.71534 3.06786 2.3916 2.3916C3.06786 1.71534 4.0459 1.3125 5.25 1.3125Z"
            fill="#06FF48"
            stroke="#06FF48"
            strokeWidth="0.75"
          />
          <path
            d="M12.75 17.0625H5.25C2.67 17.0625 0.9375 15.33 0.9375 12.75V11.25C0.9375 10.9425 1.1925 10.6875 1.5 10.6875C1.8075 10.6875 2.0625 10.9425 2.0625 11.25V12.75C2.0625 14.685 3.315 15.9375 5.25 15.9375H12.75C14.685 15.9375 15.9375 14.685 15.9375 12.75V11.25C15.9375 10.9425 16.1925 10.6875 16.5 10.6875C16.8075 10.6875 17.0625 10.9425 17.0625 11.25V12.75C17.0625 15.33 15.33 17.0625 12.75 17.0625Z"
            fill="#06FF48"
          />
          <path
            d="M16.5 9.5625H1.5C1.1925 9.5625 0.9375 9.3075 0.9375 9C0.9375 8.6925 1.1925 8.4375 1.5 8.4375H16.5C16.8075 8.4375 17.0625 8.6925 17.0625 9C17.0625 9.3075 16.8075 9.5625 16.5 9.5625Z"
            fill="#06FF48"
          />
          <path
            d="M12.375 6.75H5.625C5.415 6.75 5.25 6.585 5.25 6.375V4.875C5.25 4.2525 5.7525 3.75 6.375 3.75H11.625C12.2475 3.75 12.75 4.2525 12.75 4.875V6.375C12.75 6.585 12.585 6.75 12.375 6.75Z"
            fill="#06FF48"
          />
          <path
            d="M12.375 11.25H5.625C5.415 11.25 5.25 11.415 5.25 11.625V13.125C5.25 13.7475 5.7525 14.25 6.375 14.25H11.625C12.24 14.25 12.75 13.7475 12.75 13.125V11.625C12.75 11.415 12.585 11.25 12.375 11.25Z"
            fill="#06FF48"
          />
        </svg>
      )
    case 'scan-ticket-profile':
      return (
        <svg
          width="47"
          height="47"
          viewBox="0 0 47 47"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_d_3238_344753)">
            <path
              d="M31 23.5C31 19.3675 27.6325 16 23.5 16C19.3675 16 16 19.3675 16 23.5C16 25.675 16.9375 27.6325 18.4225 29.005C18.4225 29.0125 18.4225 29.0125 18.415 29.02C18.49 29.095 18.58 29.155 18.655 29.2225C18.7 29.26 18.7375 29.2975 18.7825 29.3275C18.9175 29.44 19.0675 29.545 19.21 29.65C19.2625 29.6875 19.3075 29.7175 19.36 29.755C19.5025 29.8525 19.6525 29.9425 19.81 30.025C19.8625 30.055 19.9225 30.0925 19.975 30.1225C20.125 30.205 20.2825 30.28 20.4475 30.3475C20.5075 30.3775 20.5675 30.4075 20.6275 30.43C20.7925 30.4975 20.9575 30.5575 21.1225 30.61C21.1825 30.6325 21.2425 30.655 21.3025 30.67C21.4825 30.7225 21.6625 30.7675 21.8425 30.8125C21.895 30.8275 21.9475 30.8425 22.0075 30.85C22.2175 30.895 22.4275 30.925 22.645 30.9475C22.675 30.9475 22.705 30.955 22.735 30.9625C22.99 30.985 23.245 31 23.5 31C23.755 31 24.01 30.985 24.2575 30.9625C24.2875 30.9625 24.3175 30.955 24.3475 30.9475C24.565 30.925 24.775 30.895 24.985 30.85C25.0375 30.8425 25.09 30.82 25.15 30.8125C25.33 30.7675 25.5175 30.73 25.69 30.67C25.75 30.6475 25.81 30.625 25.87 30.61C26.035 30.55 26.2075 30.4975 26.365 30.43C26.425 30.4075 26.485 30.3775 26.545 30.3475C26.7025 30.28 26.86 30.205 27.0175 30.1225C27.0775 30.0925 27.13 30.055 27.1825 30.025C27.3325 29.935 27.4825 29.8525 27.6325 29.755C27.685 29.725 27.73 29.6875 27.7825 29.65C27.9325 29.545 28.075 29.44 28.21 29.3275C28.255 29.29 28.2925 29.2525 28.3375 29.2225C28.42 29.155 28.5025 29.0875 28.5775 29.02C28.5775 29.0125 28.5775 29.0125 28.57 29.005C30.0625 27.6325 31 25.675 31 23.5ZM27.205 27.2275C25.1725 25.8625 21.8425 25.8625 19.795 27.2275C19.465 27.445 19.195 27.7 18.97 27.9775C17.83 26.8225 17.125 25.24 17.125 23.5C17.125 19.9825 19.9825 17.125 23.5 17.125C27.0175 17.125 29.875 19.9825 29.875 23.5C29.875 25.24 29.17 26.8225 28.03 27.9775C27.8125 27.7 27.535 27.445 27.205 27.2275Z"
              fill="#06FF48"
            />
            <path
              d="M23.5 20.0725C24.8454 20.0725 25.9375 21.1646 25.9375 22.51C25.9301 23.8271 24.9032 24.8881 23.5967 24.9397H23.4736C22.0906 24.9004 21.0625 23.8262 21.0625 22.51C21.0625 21.1646 22.1546 20.0725 23.5 20.0725Z"
              fill="#06FF48"
              stroke="#06FF48"
              strokeWidth="0.75"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_3238_344753"
              x="-1.5"
              y="-1.5"
              width="50"
              height="50"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="8" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.0240385 0 0 0 0 1 0 0 0 0 0.284295 0 0 0 1 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_3238_344753"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_3238_344753"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      )
    case 'bag-2':
      return (
        <>
          <path
            d="M5.625 5.75263V5.02513C5.625 3.33763 6.9825 1.68013 8.67 1.52263C10.68 1.32763 12.375 2.91013 12.375 4.88263V5.91763"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.74999 16.5H11.25C14.265 16.5 14.805 15.2925 14.9625 13.8225L15.525 9.3225C15.7275 7.4925 15.2025 6 12 6H5.99999C2.79749 6 2.27249 7.4925 2.47499 9.3225L3.03749 13.8225C3.19499 15.2925 3.73499 16.5 6.74999 16.5Z"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.6216 9H11.6283"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.37088 9H6.37762"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )
    case 'profile-2user':
      return (
        <>
          <path
            d="M6.86998 8.1525C6.79498 8.145 6.70498 8.145 6.62248 8.1525C4.83748 8.0925 3.41998 6.63 3.41998 4.83C3.41998 2.9925 4.90498 1.5 6.74998 1.5C8.58748 1.5 10.08 2.9925 10.08 4.83C10.0725 6.63 8.65498 8.0925 6.86998 8.1525Z"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.3075 3C13.7625 3 14.9325 4.1775 14.9325 5.625C14.9325 7.0425 13.8075 8.1975 12.405 8.25C12.345 8.2425 12.2775 8.2425 12.21 8.25"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.11998 10.92C1.30498 12.135 1.30498 14.115 3.11998 15.3225C5.18248 16.7025 8.56498 16.7025 10.6275 15.3225C12.4425 14.1075 12.4425 12.1275 10.6275 10.92C8.57248 9.5475 5.18998 9.5475 3.11998 10.92Z"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.755 15C14.295 14.8875 14.805 14.67 15.225 14.3475C16.395 13.47 16.395 12.0225 15.225 11.145C14.8125 10.83 14.31 10.62 13.7775 10.5"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )
    case 'gift':
      return (
        <>
          <path
            d="M14.9775 7.5H2.97748V13.5C2.97748 15.75 3.72748 16.5 5.97748 16.5H11.9775C14.2275 16.5 14.9775 15.75 14.9775 13.5V7.5Z"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.125 5.25V6C16.125 6.825 15.7275 7.5 14.625 7.5H3.375C2.2275 7.5 1.875 6.825 1.875 6V5.25C1.875 4.425 2.2275 3.75 3.375 3.75H14.625C15.7275 3.75 16.125 4.425 16.125 5.25Z"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.73002 3.75008H4.59002C4.33502 3.47258 4.34252 3.04508 4.61252 2.77508L5.67752 1.71008C5.95502 1.43258 6.41252 1.43258 6.69002 1.71008L8.73002 3.75008Z"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.4025 3.75008H9.26245L11.3025 1.71008C11.58 1.43258 12.0375 1.43258 12.315 1.71008L13.38 2.77508C13.65 3.04508 13.6575 3.47258 13.4025 3.75008Z"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.70502 7.5V11.355C6.70502 11.955 7.36502 12.3075 7.86752 11.985L8.57252 11.52C8.82752 11.355 9.15002 11.355 9.39752 11.52L10.065 11.97C10.56 12.3 11.2275 11.9475 11.2275 11.3475V7.5H6.70502Z"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )
    case 'arrow-down':
      return (
        <path
          d="M19.92 8.95L13.4 15.47C12.63 16.24 11.37 16.24 10.6 15.47L4.08 8.95"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      )
    case 'setting-3':
      return (
        <>
          <path
            d="M9 11.25C10.2426 11.25 11.25 10.2426 11.25 9C11.25 7.75736 10.2426 6.75 9 6.75C7.75736 6.75 6.75 7.75736 6.75 9C6.75 10.2426 7.75736 11.25 9 11.25Z"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1.5 9.66007V8.34007C1.5 7.56007 2.1375 6.91507 2.925 6.91507C4.2825 6.91507 4.8375 5.95507 4.155 4.77757C3.765 4.10257 3.9975 3.22507 4.68 2.83507L5.9775 2.09257C6.57 1.74007 7.335 1.95007 7.6875 2.54257L7.77 2.68507C8.445 3.86257 9.555 3.86257 10.2375 2.68507L10.32 2.54257C10.6725 1.95007 11.4375 1.74007 12.03 2.09257L13.3275 2.83507C14.01 3.22507 14.2425 4.10257 13.8525 4.77757C13.17 5.95507 13.725 6.91507 15.0825 6.91507C15.8625 6.91507 16.5075 7.55257 16.5075 8.34007V9.66007C16.5075 10.4401 15.87 11.0851 15.0825 11.0851C13.725 11.0851 13.17 12.0451 13.8525 13.2226C14.2425 13.9051 14.01 14.7751 13.3275 15.1651L12.03 15.9076C11.4375 16.2601 10.6725 16.0501 10.32 15.4576L10.2375 15.3151C9.5625 14.1376 8.4525 14.1376 7.77 15.3151L7.6875 15.4576C7.335 16.0501 6.57 16.2601 5.9775 15.9076L4.68 15.1651C3.9975 14.7751 3.765 13.8976 4.155 13.2226C4.8375 12.0451 4.2825 11.0851 2.925 11.0851C2.1375 11.0851 1.5 10.4401 1.5 9.66007Z"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )
    case 'logout':
      return (
        <>
          <path
            d="M8.9 7.56C9.21 3.96 11.06 2.49 15.11 2.49H15.24C19.71 2.49 21.5 4.28 21.5 8.75V15.27C21.5 19.74 19.71 21.53 15.24 21.53H15.11C11.09 21.53 9.24 20.08 8.91 16.54"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
          <path
            d="M15 12H3.62"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.85 8.65L2.5 12L5.85 15.35"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
        </>
      )
    case 'warning':
      return (
        <>
          <path
            d="M9 5.8125V9.75"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.8102 6.43503V11.565C15.8102 12.405 15.3601 13.185 14.6326 13.6125L10.1776 16.185C9.45014 16.605 8.55012 16.605 7.81512 16.185L3.36012 13.6125C2.63262 13.1925 2.18262 12.4125 2.18262 11.565V6.43503C2.18262 5.59503 2.63262 4.81499 3.36012 4.38749L7.81512 1.815C8.54262 1.395 9.44264 1.395 10.1776 1.815L14.6326 4.38749C15.3601 4.81499 15.8102 5.58753 15.8102 6.43503Z"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9 12.15V12.225"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )
    case 'stages':
      return (
        <>
          <path
            d="M9 11.625C10.6575 11.625 12 10.2825 12 8.625V4.5C12 2.8425 10.6575 1.5 9 1.5C7.3425 1.5 6 2.8425 6 4.5V8.625C6 10.2825 7.3425 11.625 9 11.625Z"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.26245 7.2373V8.51231C3.26245 11.6773 5.83495 14.2498 8.99995 14.2498C12.165 14.2498 14.7375 11.6773 14.7375 8.51231V7.2373"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.95752 4.82234C8.63252 4.57484 9.36752 4.57484 10.0425 4.82234"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.40002 6.41273C8.79752 6.30773 9.21002 6.30773 9.60752 6.41273"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9 14.25V16.5"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )
    case 'news':
      return (
        <>
          <path
            d="M2.25 3.375H15.75"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2.25 7.125H9.3525"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2.25 10.875H15.75"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2.25 14.625H9.3525"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )
    case 'notifications':
      return (
        <>
          <path
            d="M14.25 6C15.4926 6 16.5 4.99264 16.5 3.75C16.5 2.50736 15.4926 1.5 14.25 1.5C13.0074 1.5 12 2.50736 12 3.75C12 4.99264 13.0074 6 14.25 6Z"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.25 9.75H9"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.25 12.75H12"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.5 1.5H6.75C3 1.5 1.5 3 1.5 6.75V11.25C1.5 15 3 16.5 6.75 16.5H11.25C15 16.5 16.5 15 16.5 11.25V7.5"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )
    case 'wristband':
      return (
        <>
          <path
            d="M16.2116 4.88426L13.1135 1.78616C12.7101 1.38277 11.8725 1.05382 10.173 1.77762C8.99636 2.27872 7.61496 3.20529 6.28324 4.38671L5.9273 4.70245L9.0407 7.81585L9.35653 7.5357C10.0548 6.91629 10.7692 6.36878 11.4526 5.92547C10.8077 6.91919 9.94466 7.97318 8.95885 8.95899C7.97329 9.94455 6.91929 10.8076 5.92563 11.4526C6.369 10.769 6.91639 10.0548 7.53569 9.35691L7.8159 9.04107L4.70226 5.92744L4.38652 6.2834C3.20522 7.61522 2.27871 8.99661 1.7776 10.1731C1.05369 11.8726 1.38261 12.7102 1.786 13.1136L4.88404 16.2117C5.17656 16.5042 5.57708 16.6501 6.07403 16.6501C6.66968 16.6501 7.40381 16.4404 8.25571 16.0222C9.65354 15.3361 11.2286 14.1529 12.6907 12.6908C14.1529 11.2287 15.336 9.65364 16.0221 8.25581C16.7892 6.69321 16.8547 5.52737 16.2116 4.88426ZM9.08039 6.58791L7.23793 4.74542C8.38334 3.77647 9.53768 3.02244 10.5242 2.60232C11.463 2.20243 12.194 2.13433 12.4797 2.41998C12.7697 2.70996 12.6897 3.4717 12.2748 4.42747C11.2735 4.91056 10.1785 5.65135 9.08039 6.58791ZM11.9256 11.9258H9.72391V9.72408H11.9256V11.9258ZM2.60225 10.5244C3.02237 9.53797 3.7764 8.38362 4.74529 7.2381L6.58789 9.0807C5.65164 10.1782 4.91096 11.273 4.42767 12.2749C3.47157 12.6899 2.70974 12.7697 2.41978 12.4798C2.13419 12.1942 2.20239 11.4632 2.60225 10.5244ZM5.51785 15.5779L3.45107 13.5111C3.86348 13.4462 4.3575 13.2959 4.94978 13.0233C6.1623 12.4647 7.51414 11.5208 8.82755 10.3234V12.8221H11.2532C8.47164 15.3403 6.09318 16.1532 5.51785 15.5779ZM15.2175 7.86085C14.6962 8.92286 13.8611 10.1019 12.822 11.2524V8.82771H10.3233C11.521 7.51397 12.4648 6.16202 13.0232 4.94949C13.2957 4.35766 13.4463 3.86373 13.5112 3.45153L15.5778 5.51804C15.8338 5.77414 15.8737 6.52408 15.2175 7.86085Z"
            fill="currentColor"
          />
          <path
            d="M6.72119 13.4951H7.61753V14.3915H6.72119V13.4951Z"
            fill="currentColor"
          />
          <path
            d="M13.2708 6.9458H14.1671V7.84214H13.2708V6.9458Z"
            fill="currentColor"
          />
        </>
      )
    case 'chevron-down':
      return (
        <>
          <path
            d="M14.9401 6.71289L10.0501 11.6029C9.47256 12.1804 8.52756 12.1804 7.95006 11.6029L3.06006 6.71289"
            stroke="currentColor"
            strokeWidth="0.75"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )
    case 'vouchers':
      return (
        <>
          <path
            d="M15.975 8.13344C16.2675 8.13344 16.5 7.90094 16.5 7.60844V6.91094C16.5 3.83594 15.5625 2.89844 12.4875 2.89844H5.5125C2.4375 2.89844 1.5 3.83594 1.5 6.91094V7.26344C1.5 7.55594 1.7325 7.78844 2.025 7.78844C2.7 7.78844 3.2475 8.33594 3.2475 9.01094C3.2475 9.68594 2.7 10.2259 2.025 10.2259C1.7325 10.2259 1.5 10.4584 1.5 10.7509V11.1034C1.5 14.1784 2.4375 15.1159 5.5125 15.1159H12.4875C15.5625 15.1159 16.5 14.1784 16.5 11.1034C16.5 10.8109 16.2675 10.5784 15.975 10.5784C15.3 10.5784 14.7525 10.0309 14.7525 9.35594C14.7525 8.68094 15.3 8.13344 15.975 8.13344ZM6.75 6.66344C7.1625 6.66344 7.5 7.00094 7.5 7.41344C7.5 7.82594 7.17 8.16344 6.75 8.16344C6.3375 8.16344 6 7.82594 6 7.41344C6 7.00094 6.33 6.66344 6.75 6.66344ZM11.25 11.9134C10.83 11.9134 10.4925 11.5759 10.4925 11.1634C10.4925 10.7509 10.83 10.4134 11.2425 10.4134C11.655 10.4134 11.9925 10.7509 11.9925 11.1634C11.9925 11.5759 11.67 11.9134 11.25 11.9134ZM11.925 7.11344L6.8775 12.1609C6.765 12.2734 6.6225 12.3259 6.48 12.3259C6.3375 12.3259 6.195 12.2734 6.0825 12.1609C5.865 11.9434 5.865 11.5834 6.0825 11.3659L11.13 6.31844C11.3475 6.10094 11.7075 6.10094 11.925 6.31844C12.1425 6.53594 12.1425 6.89594 11.925 7.11344Z"
            fill="currentColor"
          />
        </>
      )
    case 'plus-circle':
      return (
        <>
          <path
            d="M9 1.5C4.8675 1.5 1.5 4.8675 1.5 9C1.5 13.1325 4.8675 16.5 9 16.5C13.1325 16.5 16.5 13.1325 16.5 9C16.5 4.8675 13.1325 1.5 9 1.5ZM12 9.5625H9.5625V12C9.5625 12.3075 9.3075 12.5625 9 12.5625C8.6925 12.5625 8.4375 12.3075 8.4375 12V9.5625H6C5.6925 9.5625 5.4375 9.3075 5.4375 9C5.4375 8.6925 5.6925 8.4375 6 8.4375H8.4375V6C8.4375 5.6925 8.6925 5.4375 9 5.4375C9.3075 5.4375 9.5625 5.6925 9.5625 6V8.4375H12C12.3075 8.4375 12.5625 8.6925 12.5625 9C12.5625 9.3075 12.3075 9.5625 12 9.5625Z"
            fill="currentColor"
          />
        </>
      )
    case 'profile-delete':
      return (
        <>
          <path
            d="M9 1.5C7.035 1.5 5.4375 3.0975 5.4375 5.0625C5.4375 6.99 6.945 8.55 8.91 8.6175C8.97 8.61 9.03 8.61 9.075 8.6175C9.09 8.6175 9.0975 8.6175 9.1125 8.6175C9.12 8.6175 9.12 8.6175 9.1275 8.6175C11.0475 8.55 12.555 6.99 12.5625 5.0625C12.5625 3.0975 10.965 1.5 9 1.5Z"
            fill="currentColor"
          />
          <path
            d="M12.8097 10.6127C10.7172 9.21766 7.30473 9.21766 5.19723 10.6127C4.24473 11.2502 3.71973 12.1127 3.71973 13.0352C3.71973 13.9577 4.24473 14.8127 5.18973 15.4427C6.23973 16.1477 7.61973 16.5002 8.99973 16.5002C10.3797 16.5002 11.7597 16.1477 12.8097 15.4427C13.7547 14.8052 14.2797 13.9502 14.2797 13.0202C14.2722 12.0977 13.7547 11.2427 12.8097 10.6127ZM10.4547 13.6952C10.6722 13.9127 10.6722 14.2727 10.4547 14.4902C10.3422 14.6027 10.1997 14.6552 10.0572 14.6552C9.91473 14.6552 9.77223 14.6027 9.65973 14.4902L8.99973 13.8302L8.33973 14.4902C8.22723 14.6027 8.08473 14.6552 7.94223 14.6552C7.79973 14.6552 7.65723 14.6027 7.54473 14.4902C7.32723 14.2727 7.32723 13.9127 7.54473 13.6952L8.20473 13.0352L7.54473 12.3752C7.32723 12.1577 7.32723 11.7977 7.54473 11.5802C7.76223 11.3627 8.12223 11.3627 8.33973 11.5802L8.99973 12.2402L9.65973 11.5802C9.87723 11.3627 10.2372 11.3627 10.4547 11.5802C10.6722 11.7977 10.6722 12.1577 10.4547 12.3752L9.79473 13.0352L10.4547 13.6952Z"
            fill="currentColor"
          />
        </>
      )
    case 'close-circle':
      return (
        <>
          <path
            d="M9 1.5C4.8675 1.5 1.5 4.8675 1.5 9C1.5 13.1325 4.8675 16.5 9 16.5C13.1325 16.5 16.5 13.1325 16.5 9C16.5 4.8675 13.1325 1.5 9 1.5ZM11.52 10.725C11.7375 10.9425 11.7375 11.3025 11.52 11.52C11.4075 11.6325 11.265 11.685 11.1225 11.685C10.98 11.685 10.8375 11.6325 10.725 11.52L9 9.795L7.275 11.52C7.1625 11.6325 7.02 11.685 6.8775 11.685C6.735 11.685 6.5925 11.6325 6.48 11.52C6.2625 11.3025 6.2625 10.9425 6.48 10.725L8.205 9L6.48 7.275C6.2625 7.0575 6.2625 6.6975 6.48 6.48C6.6975 6.2625 7.0575 6.2625 7.275 6.48L9 8.205L10.725 6.48C10.9425 6.2625 11.3025 6.2625 11.52 6.48C11.7375 6.6975 11.7375 7.0575 11.52 7.275L9.795 9L11.52 10.725Z"
            fill="currentColor"
          />
        </>
      )
    case 'check':
      return (
        <>
          <path
            d="M3.78516 7.96875L6.56641 10.75L12.1146 5.1875"
            stroke="currentColor"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )
    case 'Vendor Entity':
      return (
        <>
          <path
            d="M16.77 6.2025L16.5525 4.125C16.2375 1.86 15.21 0.9375 13.0125 0.9375H11.2425H10.1325H7.85248H6.74248H4.94248C2.73748 0.9375 1.71748 1.86 1.39498 4.1475L1.19248 6.21C1.11748 7.0125 1.33498 7.7925 1.80748 8.4C2.37748 9.1425 3.25498 9.5625 4.22998 9.5625C5.17498 9.5625 6.08248 9.09 6.65248 8.3325C7.16248 9.09 8.03248 9.5625 8.99998 9.5625C9.96748 9.5625 10.815 9.1125 11.3325 8.3625C11.91 9.105 12.8025 9.5625 13.7325 9.5625C14.73 9.5625 15.63 9.12 16.1925 8.34C16.6425 7.74 16.845 6.9825 16.77 6.2025Z"
            fill="currentColor"
          />
          <path
            d="M8.51253 12.4952C7.56003 12.5927 6.84003 13.4027 6.84003 14.3627V16.4177C6.84003 16.6202 7.00503 16.7852 7.20753 16.7852H10.785C10.9875 16.7852 11.1525 16.6202 11.1525 16.4177V14.6252C11.16 13.0577 10.2375 12.3152 8.51253 12.4952Z"
            fill="currentColor"
          />
          <path
            d="M16.0275 10.8025V13.0375C16.0275 15.1075 14.3475 16.7875 12.2775 16.7875C12.075 16.7875 11.91 16.6225 11.91 16.42V14.6275C11.91 13.6675 11.6175 12.9175 11.0475 12.4075C10.545 11.95 9.86247 11.725 9.01497 11.725C8.82747 11.725 8.63997 11.7325 8.43747 11.755C7.10247 11.89 6.08997 13.015 6.08997 14.365V16.42C6.08997 16.6225 5.92497 16.7875 5.72247 16.7875C3.65247 16.7875 1.97247 15.1075 1.97247 13.0375V10.8175C1.97247 10.2925 2.48997 9.94 2.97747 10.1125C3.17997 10.18 3.38247 10.2325 3.59247 10.2625C3.68247 10.2775 3.77997 10.2925 3.86997 10.2925C3.98997 10.3075 4.10997 10.315 4.22997 10.315C5.09997 10.315 5.95497 9.9925 6.62997 9.4375C7.27497 9.9925 8.11497 10.315 8.99997 10.315C9.89247 10.315 10.7175 10.0075 11.3625 9.4525C12.0375 10 12.8775 10.315 13.7325 10.315C13.8675 10.315 14.0025 10.3075 14.13 10.2925C14.22 10.285 14.3025 10.2775 14.385 10.2625C14.6175 10.2325 14.8275 10.165 15.0375 10.0975C15.525 9.9325 16.0275 10.2925 16.0275 10.8025Z"
            fill="currentColor"
          />
        </>
      )
    case 'plus-square':
      return (
        <>
          <path
            d="M6 9H12"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9 12V6"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.75 16.5H11.25C15 16.5 16.5 15 16.5 11.25V6.75C16.5 3 15 1.5 11.25 1.5H6.75C3 1.5 1.5 3 1.5 6.75V11.25C1.5 15 3 16.5 6.75 16.5Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )
    case 'user-search':
      return (
        <>
          <path
            d="M20.6188 20.6198C25.3635 20.6198 29.2099 16.7734 29.2099 12.0287C29.2099 7.2839 25.3635 3.4375 20.6188 3.4375C15.874 3.4375 12.0276 7.2839 12.0276 12.0287C12.0276 16.7734 15.874 20.6198 20.6188 20.6198Z"
            stroke="white"
            strokeWidth="2.52212"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.85913 37.8011C5.85913 31.1515 12.4744 25.7734 20.6188 25.7734"
            stroke="white"
            strokeWidth="2.52212"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M31.2718 36.7702C34.3085 36.7702 36.7702 34.3085 36.7702 31.2718C36.7702 28.2352 34.3085 25.7734 31.2718 25.7734C28.2352 25.7734 25.7734 28.2352 25.7734 31.2718C25.7734 34.3085 28.2352 36.7702 31.2718 36.7702Z"
            stroke="#06FF48"
            strokeWidth="2.52212"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M37.801 37.8042L36.0828 36.0859"
            stroke="#06FF48"
            strokeWidth="2.52212"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )
    case 'ticket-customize':
      return (
        <>
          <path
            d="M32.4919 25.249C32.4919 27.4655 34.3132 29.2697 36.5297 29.2697C36.5297 35.7131 34.9146 37.3282 28.4712 37.3282H12.3542C5.91079 37.3282 4.29565 35.7131 4.29565 29.2697V28.4793C6.51218 28.4793 8.3335 26.658 8.3335 24.4414C8.3335 22.2249 6.51218 20.4036 4.29565 20.4036V19.6132C4.31284 13.1698 5.91079 11.5547 12.3542 11.5547H28.454C34.8974 11.5547 36.5125 13.1698 36.5125 19.6132V21.2283C34.296 21.2283 32.4919 23.0153 32.4919 25.249Z"
            stroke="white"
            strokeWidth="2.52212"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M27.8543 11.5519H12.2356L17.27 6.51743C21.3766 2.41086 23.4385 2.41086 27.5451 6.51743L28.576 7.54837C27.4935 8.63086 27.2358 10.2288 27.8543 11.5519Z"
            stroke="white"
            strokeWidth="2.52212"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.9744 11.5547L16.9744 37.3282"
            stroke="#06FF48"
            strokeWidth="2.52212"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="8.41 8.41"
          />
        </>
      )
    case 'users':
      return (
        <>
          <path
            d="M15.7391 18.6782C15.5673 18.6611 15.3611 18.6611 15.1721 18.6782C11.0827 18.5408 7.83521 15.1902 7.83521 11.0665C7.83521 6.85679 11.2373 3.4375 15.4642 3.4375C19.6738 3.4375 23.0931 6.85679 23.0931 11.0665C23.0759 15.1902 19.8285 18.5408 15.7391 18.6782Z"
            stroke="white"
            strokeWidth="2.52212"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M28.1963 6.875C31.5296 6.875 34.2101 9.57263 34.2101 12.8888C34.2101 16.1363 31.6327 18.7824 28.4196 18.9026C28.2822 18.8855 28.1275 18.8855 27.9729 18.9026"
            stroke="white"
            strokeWidth="2.52212"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.14789 25.0223C2.98977 27.8059 2.98977 32.342 7.14789 35.1084C11.873 38.2699 19.6223 38.2699 24.3474 35.1084C28.5055 32.3248 28.5055 27.7887 24.3474 25.0223C19.6395 21.878 11.8902 21.878 7.14789 25.0223Z"
            stroke="#06FF48"
            strokeWidth="2.52212"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M31.5125 34.3641C32.7496 34.1064 33.918 33.6081 34.8802 32.8692C37.5606 30.8589 37.5606 27.5427 34.8802 25.5324C33.9352 24.8107 32.7839 24.3296 31.564 24.0547"
            stroke="#06FF48"
            strokeWidth="2.52212"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )
    case 'calendar-search':
      return (
        <>
          <path
            d="M13.7461 3.4375V8.5922"
            stroke="white"
            strokeWidth="2.52212"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M27.4917 3.4375V8.5922"
            stroke="white"
            strokeWidth="2.52212"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M31.2718 36.7701C34.3084 36.7701 36.7701 34.3085 36.7701 31.2718C36.7701 28.2352 34.3084 25.7734 31.2718 25.7734C28.2351 25.7734 25.7734 28.2352 25.7734 31.2718C25.7734 34.3085 28.2351 36.7701 31.2718 36.7701Z"
            stroke="#06FF48"
            strokeWidth="2.52212"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M37.8012 37.8042L36.083 36.0859"
            stroke="#06FF48"
            strokeWidth="2.52212"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.01367 15.6172H35.2236"
            stroke="white"
            strokeWidth="2.52212"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22.9729 37.803H13.746C7.73214 37.803 5.15479 34.3665 5.15479 29.2118V14.6068C5.15479 9.45209 7.73214 6.01562 13.746 6.01562H27.4918C33.5056 6.01562 36.083 9.45209 36.083 14.6068V22.3388"
            stroke="white"
            strokeWidth="2.52212"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.6109 23.5388H20.6263"
            stroke="white"
            strokeWidth="3.36283"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.2515 23.5388H14.267"
            stroke="white"
            strokeWidth="3.36283"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.2515 28.6951H14.267"
            stroke="white"
            strokeWidth="3.36283"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )
    case 'plus':
      return (
        <>
          <path
            d="M4.5 9H13.5"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9 13.5V4.5"
            stroke="currentColor"
            strokeWidth="1.125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )
    case 'clock':
      return (
        <>
          <path
            d="M16.5 9C16.5 13.14 13.14 16.5 9 16.5C4.86 16.5 1.5 13.14 1.5 9C1.5 4.86 4.86 1.5 9 1.5C13.14 1.5 16.5 4.86 16.5 9Z"
            stroke="currentColor"
            strokeWidth="0.75"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.7827 11.3853L9.45766 9.99781C9.05266 9.75781 8.72266 9.18031 8.72266 8.70781V5.63281"
            stroke="currentColor"
            strokeWidth="0.75"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )
    case 'arrow-left':
      return (
        <>
          <path
            d="M7.1775 4.44727L2.625 8.99977L7.1775 13.5523"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.375 9H2.7525"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )
    case 'refresh':
      return (
        <>
          <path
            d="M9 2C12.8639 2 16 5.13614 16 9C16 12.8639 12.8639 16 9 16C5.13614 16 2 12.8639 2 9C2 5.13614 5.13614 2 9 2ZM12.6484 8.4375C12.0523 8.35234 11.5295 8.76833 11.4453 9.33887C11.3626 9.8922 11.1232 10.3767 10.7539 10.7461C10.2069 11.2931 9.46821 11.5298 8.75391 11.457C8.86469 11.2894 8.92969 11.0895 8.92969 10.875C8.92969 10.2914 8.45083 9.8125 7.86719 9.8125H5.86523C5.28159 9.8125 4.80273 10.2914 4.80273 10.875V12.8779C4.80297 13.4614 5.28174 13.9404 5.86523 13.9404C6.37886 13.9403 6.81098 13.5689 6.90723 13.082C7.55925 13.4225 8.27561 13.6025 9 13.6025C10.1763 13.6025 11.3552 13.1565 12.2559 12.2559C12.9575 11.5543 13.4017 10.6524 13.5518 9.64355L13.5537 9.63086C13.623 9.06305 13.2346 8.52313 12.6494 8.4375H12.6484ZM12.1279 4.05273C11.6109 4.05273 11.1755 4.42833 11.083 4.91992C9.3601 4.0335 7.19506 4.30055 5.74512 5.74316L5.74219 5.74609C5.04375 6.45294 4.59774 7.35374 4.45508 8.35059C4.37102 8.92691 4.77425 9.47481 5.35156 9.54883V9.5459C5.42037 9.55737 5.47356 9.55958 5.49707 9.55957C6.01458 9.55957 6.47162 9.18365 6.54688 8.6543C6.62957 8.10085 6.8689 7.61554 7.23828 7.24609C7.78496 6.69942 8.52341 6.46278 9.2373 6.53516C9.12673 6.70262 9.06256 6.90297 9.0625 7.11719C9.0625 7.70083 9.54136 8.17969 10.125 8.17969H12.1279C12.7114 8.17945 13.1904 7.70069 13.1904 7.11719V5.11523C13.1904 4.53174 12.7114 4.05297 12.1279 4.05273Z"
            fill="currentColor"
            stroke="currentColor"
          />
        </>
      )
    case 'stages-bold':
      return (
        <>
          <path
            d="M8.99995 16.4459C5.21995 16.4459 2.13745 13.3709 2.13745 9.58344V8.17344C2.13745 7.88094 2.37745 7.64844 2.66245 7.64844C2.94745 7.64844 3.18745 7.88844 3.18745 8.17344V9.58344C3.18745 12.7859 5.78995 15.3884 8.99245 15.3884C12.195 15.3884 14.7975 12.7859 14.7975 9.58344V8.17344C14.7975 7.88094 15.0375 7.64844 15.3225 7.64844C15.6075 7.64844 15.8475 7.88844 15.8475 8.17344V9.58344C15.8625 13.3709 12.78 16.4459 8.99995 16.4459Z"
            fill="currentColor"
          />
          <path
            d="M9.00005 1.5C6.48005 1.5 4.42505 3.555 4.42505 6.075V9.5925C4.42505 12.1125 6.48005 14.1675 9.00005 14.1675C11.52 14.1675 13.575 12.1125 13.575 9.5925V6.075C13.575 3.555 11.52 1.5 9.00005 1.5ZM10.635 7.9425C10.5825 8.145 10.395 8.28 10.1925 8.28C10.155 8.28 10.11 8.2725 10.0725 8.265C9.30755 8.055 8.49755 8.055 7.73255 8.265C7.48505 8.3325 7.23755 8.19 7.17005 7.9425C7.10255 7.7025 7.24505 7.4475 7.49255 7.38C8.41505 7.125 9.39005 7.125 10.3125 7.38C10.56 7.4475 10.7025 7.695 10.635 7.9425ZM11.2725 5.865C11.205 6.0525 11.0325 6.165 10.845 6.165C10.7925 6.165 10.74 6.1575 10.6875 6.135C9.54005 5.715 8.28005 5.715 7.13255 6.135C6.89255 6.225 6.63005 6.105 6.54005 5.865C6.45755 5.6325 6.57755 5.37 6.81755 5.28C8.16755 4.7925 9.65255 4.7925 10.995 5.28C11.235 5.37 11.355 5.6325 11.2725 5.865Z"
            fill="currentColor"
          />
        </>
      )
    case 'settings-switches':
      return (
        <>
          <path
            d="M12.1425 1.5H5.8575C3.1275 1.5 1.5 3.1275 1.5 5.8575V12.135C1.5 14.8725 3.1275 16.5 5.8575 16.5H12.135C14.865 16.5 16.4925 14.8725 16.4925 12.1425V5.8575C16.5 3.1275 14.8725 1.5 12.1425 1.5ZM5.7525 4.125C5.7525 3.8175 6.0075 3.5625 6.315 3.5625C6.6225 3.5625 6.8775 3.8175 6.8775 4.125V7.05C6.8775 7.3575 6.6225 7.6125 6.315 7.6125C6.0075 7.6125 5.7525 7.3575 5.7525 7.05V4.125ZM7.22708 12.2834C7.02795 12.3829 6.8775 12.5732 6.8775 12.7958V13.875C6.8775 14.1825 6.6225 14.4375 6.315 14.4375C6.0075 14.4375 5.7525 14.1825 5.7525 13.875V12.7958C5.7525 12.5732 5.60201 12.3829 5.40299 12.2832C4.73305 11.9476 4.275 11.2603 4.275 10.4625C4.275 9.3375 5.19 8.415 6.315 8.415C7.44 8.415 8.3625 9.33 8.3625 10.4625C8.3625 11.2604 7.89877 11.9479 7.22708 12.2834ZM12.2475 13.875C12.2475 14.1825 11.9925 14.4375 11.685 14.4375C11.3775 14.4375 11.1225 14.1825 11.1225 13.875V10.95C11.1225 10.6425 11.3775 10.3875 11.685 10.3875C11.9925 10.3875 12.2475 10.6425 12.2475 10.95V13.875ZM11.685 9.5775C10.56 9.5775 9.6375 8.6625 9.6375 7.53C9.6375 6.73211 10.1012 6.04463 10.7729 5.70911C10.9721 5.60964 11.1225 5.41931 11.1225 5.19671V4.125C11.1225 3.8175 11.3775 3.5625 11.685 3.5625C11.9925 3.5625 12.2475 3.8175 12.2475 4.125V5.20421C12.2475 5.42681 12.398 5.61709 12.597 5.71678C13.2669 6.05236 13.725 6.73974 13.725 7.5375C13.725 8.6625 12.81 9.5775 11.685 9.5775Z"
            fill="currentColor"
          />
        </>
      )
    case 'close':
      return (
        <>
          <path
            d="M7 17L17 7"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17 17L7 7"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )
    case 'artists-bold':
      return (
        <>
          <path
            d="M10.2977 2.62906L11.6177 5.26906C11.7977 5.63656 12.2777 5.98906 12.6827 6.05656L15.0752 6.45406C16.6052 6.70906 16.9652 7.81906 15.8627 8.91406L14.0027 10.7741C13.6877 11.0891 13.5152 11.6966 13.6127 12.1316L14.1452 14.4341C14.5652 16.2566 13.5977 16.9616 11.9852 16.0091L9.74268 14.6816C9.33768 14.4416 8.67018 14.4416 8.25768 14.6816L6.01518 16.0091C4.41018 16.9616 3.43518 16.2491 3.85518 14.4341L4.38768 12.1316C4.48518 11.6966 4.31268 11.0891 3.99768 10.7741L2.13768 8.91406C1.04268 7.81906 1.39518 6.70906 2.92518 6.45406L5.31768 6.05656C5.71518 5.98906 6.19518 5.63656 6.37518 5.26906L7.69518 2.62906C8.41518 1.19656 9.58518 1.19656 10.2977 2.62906Z"
            fill="currentColor"
          />
        </>
      )
    case 'arrow-up-down':
      return (
        <>
          <g clipPath="url(#clip0_2004_12543)">
            <g clipPath="url(#clip1_2004_12543)">
              <path
                d="M7.8499 5.54688L7.1499 6.29688L3.9999 3.14688L0.849902 6.29688L0.149902 5.54688L3.9999 1.69687L7.8499 5.54688Z"
                fill="currentColor"
              />
            </g>
          </g>
          <g clipPath="url(#clip2_2004_12543)">
            <g clipPath="url(#clip3_2004_12543)">
              <path
                d="M0.150098 10.4531L0.850098 9.70312L4.0001 12.8531L7.1501 9.70312L7.8501 10.4531L4.0001 14.3031L0.150098 10.4531Z"
                fill="currentColor"
              />
            </g>
          </g>
          <defs>
            <clipPath id="clip0_2004_12543">
              <rect
                width="8"
                height="8"
                fill="currentColor"
                transform="translate(0 8) rotate(-90)"
              />
            </clipPath>
            <clipPath id="clip1_2004_12543">
              <rect
                width="8"
                height="8"
                fill="currentColor"
                transform="translate(0 8) rotate(-90)"
              />
            </clipPath>
            <clipPath id="clip2_2004_12543">
              <rect
                width="8"
                height="8"
                fill="currentColor"
                transform="translate(8 8) rotate(90)"
              />
            </clipPath>
            <clipPath id="clip3_2004_12543">
              <rect
                width="8"
                height="8"
                fill="currentColor"
                transform="translate(8 8) rotate(90)"
              />
            </clipPath>
          </defs>
        </>
      )
    case 'double-chevron-left':
      return (
        <>
          <path
            d="M11.9025 19.9181L18.4225 13.3981C19.1925 12.6281 19.1925 11.3681 18.4225 10.5981L11.9025 4.07812"
            stroke="currentColor"
            strokeOpacity="0.5"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.9025 19.9181L12.4225 13.3981C13.1925 12.6281 13.1925 11.3681 12.4225 10.5981L5.9025 4.07812"
            stroke="currentColor"
            strokeOpacity="0.5"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )
    case 'chevron-left':
      return (
        <>
          <path
            d="M14.9998 19.9181L8.47984 13.3981C7.70984 12.6281 7.70984 11.3681 8.47984 10.5981L14.9998 4.07812"
            stroke="currentColor"
            strokeOpacity="0.5"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )
    case 'warning-2':
      return (
        <>
          <path
            d="M14.6329 4.3875L10.1779 1.815C9.45043 1.395 8.55043 1.395 7.81543 1.815L3.36793 4.3875C2.64043 4.8075 2.19043 5.5875 2.19043 6.435V11.565C2.19043 12.405 2.64043 13.185 3.36793 13.6125L7.82293 16.185C8.55043 16.605 9.45043 16.605 10.1854 16.185L14.6404 13.6125C15.3679 13.1925 15.8179 12.4125 15.8179 11.565V6.435C15.8104 5.5875 15.3604 4.815 14.6329 4.3875ZM8.43793 5.8125C8.43793 5.505 8.69293 5.25 9.00043 5.25C9.30793 5.25 9.56293 5.505 9.56293 5.8125V9.75C9.56293 10.0575 9.30793 10.3125 9.00043 10.3125C8.69293 10.3125 8.43793 10.0575 8.43793 9.75V5.8125ZM9.69043 12.4725C9.65293 12.5625 9.60043 12.645 9.53293 12.72C9.39043 12.8625 9.20293 12.9375 9.00043 12.9375C8.90293 12.9375 8.80543 12.915 8.71543 12.8775C8.61793 12.84 8.54293 12.7875 8.46793 12.72C8.40043 12.645 8.34793 12.5625 8.30293 12.4725C8.26543 12.3825 8.25043 12.285 8.25043 12.1875C8.25043 11.9925 8.32543 11.7975 8.46793 11.655C8.54293 11.5875 8.61793 11.535 8.71543 11.4975C8.99293 11.3775 9.32293 11.445 9.53293 11.655C9.60043 11.73 9.65293 11.805 9.69043 11.9025C9.72793 11.9925 9.75043 12.09 9.75043 12.1875C9.75043 12.285 9.72793 12.3825 9.69043 12.4725Z"
            fill="currentColor"
          />
        </>
      )
    case 'calendar-2':
      return (
        <>
          <path
            d="M12.5627 2.67V1.5C12.5627 1.1925 12.3077 0.9375 12.0002 0.9375C11.6927 0.9375 11.4377 1.1925 11.4377 1.5V2.625H6.56267V1.5C6.56267 1.1925 6.30767 0.9375 6.00017 0.9375C5.69267 0.9375 5.43767 1.1925 5.43767 1.5V2.67C3.41267 2.8575 2.43017 4.065 2.28017 5.8575C2.26517 6.075 2.44517 6.255 2.65517 6.255H15.3452C15.5627 6.255 15.7427 6.0675 15.7202 5.8575C15.5702 4.065 14.5877 2.8575 12.5627 2.67Z"
            fill="currentColor"
          />
          <path
            d="M15 7.38281H3C2.5875 7.38281 2.25 7.72031 2.25 8.13281V12.7528C2.25 15.0028 3.375 16.5028 6 16.5028H12C14.625 16.5028 15.75 15.0028 15.75 12.7528V8.13281C15.75 7.72031 15.4125 7.38281 15 7.38281ZM6.9075 13.6603C6.8325 13.7278 6.75 13.7803 6.66 13.8178C6.57 13.8553 6.4725 13.8778 6.375 13.8778C6.2775 13.8778 6.18 13.8553 6.09 13.8178C6 13.7803 5.9175 13.7278 5.8425 13.6603C5.7075 13.5178 5.625 13.3228 5.625 13.1278C5.625 12.9328 5.7075 12.7378 5.8425 12.5953C5.9175 12.5278 6 12.4753 6.09 12.4378C6.27 12.3628 6.48 12.3628 6.66 12.4378C6.75 12.4753 6.8325 12.5278 6.9075 12.5953C7.0425 12.7378 7.125 12.9328 7.125 13.1278C7.125 13.3228 7.0425 13.5178 6.9075 13.6603ZM7.065 10.7878C7.0275 10.8778 6.975 10.9603 6.9075 11.0353C6.8325 11.1028 6.75 11.1553 6.66 11.1928C6.57 11.2303 6.4725 11.2528 6.375 11.2528C6.2775 11.2528 6.18 11.2303 6.09 11.1928C6 11.1553 5.9175 11.1028 5.8425 11.0353C5.775 10.9603 5.7225 10.8778 5.685 10.7878C5.6475 10.6978 5.625 10.6003 5.625 10.5028C5.625 10.4053 5.6475 10.3078 5.685 10.2178C5.7225 10.1278 5.775 10.0453 5.8425 9.97031C5.9175 9.90281 6 9.85031 6.09 9.81281C6.27 9.73781 6.48 9.73781 6.66 9.81281C6.75 9.85031 6.8325 9.90281 6.9075 9.97031C6.975 10.0453 7.0275 10.1278 7.065 10.2178C7.1025 10.3078 7.125 10.4053 7.125 10.5028C7.125 10.6003 7.1025 10.6978 7.065 10.7878ZM9.5325 11.0353C9.4575 11.1028 9.375 11.1553 9.285 11.1928C9.195 11.2303 9.0975 11.2528 9 11.2528C8.9025 11.2528 8.805 11.2303 8.715 11.1928C8.625 11.1553 8.5425 11.1028 8.4675 11.0353C8.3325 10.8928 8.25 10.6978 8.25 10.5028C8.25 10.3078 8.3325 10.1128 8.4675 9.97031C8.5425 9.90281 8.625 9.85031 8.715 9.81281C8.895 9.73031 9.105 9.73031 9.285 9.81281C9.375 9.85031 9.4575 9.90281 9.5325 9.97031C9.6675 10.1128 9.75 10.3078 9.75 10.5028C9.75 10.6978 9.6675 10.8928 9.5325 11.0353Z"
            fill="currentColor"
          />
        </>
      )
    case 'wallet':
      return (
        <>
          <path
            d="M14.5801 10.2266H15.6992L15.7129 10.2275V10.9756C15.7119 10.9759 15.7095 10.9764 15.7061 10.9766H14.625C14.3938 10.9766 14.2239 10.8068 14.2109 10.6406V10.6328L14.2119 10.5498C14.2231 10.4678 14.2626 10.3917 14.3203 10.334L14.3271 10.3271C14.3852 10.2659 14.4713 10.2266 14.5801 10.2266Z"
            fill="currentColor"
            stroke="currentColor"
            stroke-width="0.75"
          />
          <path
            d="M13.4929 9.51406C13.1179 9.88156 12.9379 10.4291 13.0879 10.9991C13.2829 11.6966 13.9654 12.1391 14.6854 12.1391H15.3379C15.7504 12.1391 16.0879 12.4766 16.0879 12.8891V13.0316C16.0879 14.5841 14.8204 15.8516 13.2679 15.8516H4.65789C3.10539 15.8516 1.83789 14.5841 1.83789 13.0316V7.98406C1.83789 7.06156 2.28039 6.24406 2.96289 5.73406C3.43539 5.37406 4.02039 5.16406 4.65789 5.16406H13.2679C14.8204 5.16406 16.0879 6.43156 16.0879 7.98406V8.31406C16.0879 8.72656 15.7504 9.06406 15.3379 9.06406H14.5729C14.1529 9.06406 13.7704 9.22906 13.4929 9.51406Z"
            fill="currentColor"
          />
          <path
            d="M12.1503 3.615C12.3528 3.8175 12.1803 4.1325 11.8953 4.1325L6.13529 4.125C5.80529 4.125 5.63279 3.72 5.87279 3.4875L7.08779 2.265C8.11529 1.245 9.78029 1.245 10.8078 2.265L12.1203 3.5925C12.1278 3.6 12.1428 3.6075 12.1503 3.615Z"
            fill="currentColor"
          />
        </>
      )
    case 'ticket-3':
      return (
        <>
          <path
            d="M12.8925 3.72C12.8925 3.7275 12.8925 3.7275 12.8925 3.735C12.705 3.7275 12.5175 3.72 12.315 3.72H6.54004L7.34254 2.925C8.07754 2.1825 8.88754 1.5 9.82504 1.5C10.77 1.5 11.58 2.1825 12.315 2.925L12.735 3.345C12.84 3.4425 12.8925 3.5775 12.8925 3.72Z"
            fill="currentColor"
          />
          <path
            d="M15.6297 9.87594C15.9222 9.87594 16.1547 9.63594 16.1547 9.33594V8.67594C16.1547 5.72844 15.2547 4.83594 12.3147 4.83594H7.58973H5.68473C2.74473 4.83594 1.84473 5.73594 1.84473 8.67594V8.99844C1.84473 9.29844 2.07723 9.53094 2.36973 9.53094C2.99973 9.53094 3.50223 10.0409 3.50223 10.6634C3.50223 11.2859 2.99973 11.8034 2.36973 11.8034C2.07723 11.8034 1.84473 12.0359 1.84473 12.3359V12.6584C1.84473 15.6059 2.74473 16.4984 5.68473 16.4984H7.58223H12.3072C15.2472 16.4984 16.1472 15.5984 16.1472 12.6584C16.1472 12.3659 15.9147 12.1259 15.6222 12.1259C14.9922 12.1259 14.4897 11.6234 14.4897 11.0009C14.4972 10.3784 14.9997 9.87594 15.6297 9.87594ZM8.11473 14.1434C8.11473 14.4359 7.87473 14.6759 7.58223 14.6759C7.28973 14.6759 7.04973 14.4359 7.04973 14.1434V12.1334C7.04973 11.8409 7.28973 11.6009 7.58223 11.6009C7.87473 11.6009 8.11473 11.8409 8.11473 12.1334V14.1434ZM8.11473 9.20094C8.11473 9.49344 7.87473 9.73344 7.58223 9.73344C7.28973 9.73344 7.04973 9.49344 7.04973 9.20094V7.19094C7.04973 6.89844 7.28973 6.65844 7.58223 6.65844C7.87473 6.65844 8.11473 6.89844 8.11473 7.19094V9.20094Z"
            fill="currentColor"
          />
        </>
      )
    case 'flag-2':
      return (
        <>
          <path
            d="M13.5148 9.2475L12.5998 8.3325C12.3823 8.145 12.2548 7.8675 12.2473 7.56C12.2323 7.2225 12.3673 6.885 12.6148 6.6375L13.5148 5.7375C14.2948 4.9575 14.5873 4.2075 14.3398 3.615C14.0998 3.03 13.3573 2.7075 12.2623 2.7075H4.4248V2.0625C4.4248 1.755 4.1698 1.5 3.8623 1.5C3.5548 1.5 3.2998 1.755 3.2998 2.0625V15.9375C3.2998 16.245 3.5548 16.5 3.8623 16.5C4.1698 16.5 4.4248 16.245 4.4248 15.9375V12.2775H12.2623C13.3423 12.2775 14.0698 11.9475 14.3173 11.355C14.5648 10.7625 14.2798 10.02 13.5148 9.2475Z"
            fill="currentColor"
          />
        </>
      )
    case 'export-2':
      return (
        <>
          <path
            d="M12.1425 1.5H5.8575C3.1275 1.5 1.5 3.1275 1.5 5.8575V12.135C1.5 14.8725 3.1275 16.5 5.8575 16.5H12.135C14.865 16.5 16.4925 14.8725 16.4925 12.1425V5.8575C16.5 3.1275 14.8725 1.5 12.1425 1.5ZM12.9375 9.2475C12.9375 9.555 12.6825 9.81 12.375 9.81C12.0675 9.81 11.8125 9.555 11.8125 9.2475V6.9825L6.0225 12.7725C5.91 12.885 5.7675 12.9375 5.625 12.9375C5.4825 12.9375 5.34 12.885 5.2275 12.7725C5.01 12.555 5.01 12.195 5.2275 11.9775L11.0175 6.1875H8.7525C8.445 6.1875 8.19 5.9325 8.19 5.625C8.19 5.3175 8.445 5.0625 8.7525 5.0625H12.375C12.6825 5.0625 12.9375 5.3175 12.9375 5.625V9.2475Z"
            fill="currentColor"
          />
        </>
      )
    case 'info-2':
      return (
        <>
          <path
            d="M8.99968 1.5C4.8581 1.5 1.5 4.8581 1.5 8.99968C1.5 13.1413 4.8581 16.5 8.99968 16.5C13.1413 16.5 16.5 13.1413 16.5 8.99968C16.5 4.8581 13.1413 1.5 8.99968 1.5ZM10.561 13.1235C10.1749 13.2759 9.86762 13.3914 9.63714 13.4714C9.4073 13.5514 9.14 13.5914 8.83587 13.5914C8.36857 13.5914 8.00476 13.4771 7.74571 13.2492C7.48667 13.0213 7.35778 12.7324 7.35778 12.3813C7.35778 12.2448 7.3673 12.1051 7.38635 11.9629C7.40603 11.8206 7.43714 11.6606 7.47968 11.481L7.96286 9.77429C8.0054 9.61048 8.04222 9.45492 8.07143 9.31016C8.10064 9.16413 8.1146 9.03016 8.1146 8.90825C8.1146 8.69111 8.06952 8.53873 7.98 8.45302C7.88921 8.3673 7.71841 8.3254 7.46381 8.3254C7.33937 8.3254 7.21111 8.34381 7.07968 8.38254C6.94952 8.42254 6.83651 8.45873 6.74381 8.49429L6.87143 7.96857C7.18762 7.83968 7.49048 7.72921 7.77937 7.63778C8.06825 7.54508 8.34127 7.49937 8.59841 7.49937C9.06254 7.49937 9.42064 7.61238 9.6727 7.83587C9.92349 8.06 10.0498 8.35143 10.0498 8.70952C10.0498 8.78381 10.041 8.9146 10.0238 9.10127C10.0067 9.28857 9.97429 9.45937 9.9273 9.61619L9.44667 11.3178C9.4073 11.4543 9.37238 11.6105 9.34064 11.7851C9.30952 11.9597 9.29429 12.093 9.29429 12.1825C9.29429 12.4086 9.34444 12.5629 9.44603 12.6448C9.54635 12.7267 9.72222 12.7679 9.97111 12.7679C10.0886 12.7679 10.22 12.747 10.3686 12.7063C10.5159 12.6657 10.6225 12.6295 10.6898 12.5984L10.561 13.1235ZM10.4759 6.21683C10.2517 6.42508 9.9819 6.52921 9.66635 6.52921C9.35143 6.52921 9.07968 6.42508 8.85365 6.21683C8.62889 6.00857 8.51524 5.75524 8.51524 5.45937C8.51524 5.16413 8.62952 4.91016 8.85365 4.7C9.07968 4.48921 9.35143 4.38444 9.66635 4.38444C9.9819 4.38444 10.2524 4.48921 10.4759 4.7C10.7 4.91016 10.8124 5.16413 10.8124 5.45937C10.8124 5.75587 10.7 6.00857 10.4759 6.21683Z"
            fill="currentColor"
          />
        </>
      )
    case 'edit-2':
      return (
        <>
          <path
            d="M15.75 16.5H2.25C1.9425 16.5 1.6875 16.245 1.6875 15.9375C1.6875 15.63 1.9425 15.375 2.25 15.375H15.75C16.0575 15.375 16.3125 15.63 16.3125 15.9375C16.3125 16.245 16.0575 16.5 15.75 16.5Z"
            fill="currentColor"
          />
          <path
            d="M12.0898 2.00391C12.6329 2.00753 13.2341 2.28592 13.9111 2.96289L13.9131 2.96484C14.608 3.65281 14.8728 4.25085 14.8672 4.80957V4.81445C14.8671 5.35182 14.6022 5.94375 13.9131 6.62598L13.9102 6.62988L13.0947 7.4502C11.3555 6.91416 9.96126 5.52287 9.42383 3.78418L10.2461 2.96289C10.9397 2.26929 11.5484 2.0004 12.0898 2.00391Z"
            fill="currentColor"
            stroke="currentColor"
          />
          <path
            d="M11.7077 8.64906C11.4902 8.54406 11.2802 8.43906 11.0777 8.31906C10.9127 8.22156 10.7552 8.11656 10.5977 8.00406C10.4702 7.92156 10.3202 7.80156 10.1777 7.68156C10.1627 7.67406 10.1102 7.62906 10.0502 7.56906C9.80274 7.35906 9.52524 7.08906 9.27774 6.78906C9.25524 6.77406 9.21774 6.72156 9.16524 6.65406C9.09024 6.56406 8.96274 6.41406 8.85024 6.24156C8.76024 6.12906 8.65524 5.96406 8.55774 5.79906C8.43774 5.59656 8.33274 5.39406 8.22774 5.18406C8.09007 4.88906 7.70288 4.80142 7.47268 5.03162L3.25524 9.24906C3.15774 9.34656 3.06774 9.53406 3.04524 9.66156L2.64024 12.5341C2.56524 13.0441 2.70774 13.5241 3.02274 13.8466C3.29274 14.1091 3.66774 14.2516 4.07274 14.2516C4.16274 14.2516 4.25274 14.2441 4.34274 14.2291L7.22274 13.8241C7.35774 13.8016 7.54524 13.7116 7.63524 13.6141L11.8596 9.38966C12.0852 9.16406 12.0005 8.77591 11.7077 8.64906Z"
            fill="currentColor"
          />
        </>
      )
    case 'refresh-square-2':
      return (
        <>
          <path
            d="M6.75 16.5H11.25C15 16.5 16.5 15 16.5 11.25V6.75C16.5 3 15 1.5 11.25 1.5H6.75C3 1.5 1.5 3 1.5 6.75V11.25C1.5 15 3 16.5 6.75 16.5Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M5.33249 10.83V12.8925Z" fill="currentColor" />
          <path
            d="M13.125 9C13.125 11.28 11.28 13.125 9 13.125C6.72 13.125 5.33249 10.83 5.33249 10.83M5.33249 10.83H7.1925M5.33249 10.83V12.8925M4.875 9C4.875 6.72 6.705 4.875 9 4.875C11.7525 4.875 13.125 7.17 13.125 7.17M13.125 7.17V5.1075M13.125 7.17H11.295"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )
    case 'document-text':
      return (
        <>
          <path
            d="M11.8498 1.65786C11.5423 1.35036 11.0098 1.56036 11.0098 1.98786V4.60536C11.0098 5.70036 11.9398 6.60786 13.0723 6.60786C13.7848 6.61536 14.7748 6.61536 15.6223 6.61536C16.0498 6.61536 16.2748 6.11286 15.9748 5.81286C14.8948 4.72536 12.9598 2.76786 11.8498 1.65786Z"
            fill="currentColor"
          />
          <path
            d="M6.05273 2H9.23242C9.36878 2 9.48242 2.11364 9.48242 2.25V4.41797C9.48268 6.47124 11.1538 8.14232 13.207 8.14258H15.375C15.5114 8.14258 15.625 8.25622 15.625 8.39258V12.3223C15.625 13.5382 15.2047 14.4456 14.5605 15.0508C13.9113 15.6606 12.9952 16 11.9473 16H6.05273C5.00485 16 4.08871 15.6606 3.43945 15.0508C2.79527 14.4456 2.375 13.5382 2.375 12.3223V5.67773C2.375 4.46178 2.79527 3.55435 3.43945 2.94922C4.08871 2.33944 5.00485 2 6.05273 2ZM5.625 11.6875C5.04136 11.6875 4.5625 12.1664 4.5625 12.75C4.5625 13.3336 5.04136 13.8125 5.625 13.8125H8.625C9.20864 13.8125 9.6875 13.3336 9.6875 12.75C9.6875 12.1664 9.20864 11.6875 8.625 11.6875H5.625ZM5.625 8.6875C5.04136 8.6875 4.5625 9.16636 4.5625 9.75C4.5625 10.3336 5.04136 10.8125 5.625 10.8125H10.125C10.7086 10.8125 11.1875 10.3336 11.1875 9.75C11.1875 9.16636 10.7086 8.6875 10.125 8.6875H5.625Z"
            fill="currentColor"
            stroke="currentColor"
          />
        </>
      )
    case 'copy':
      return (
        <>
          <path
            d="M12 9.675V12.825C12 15.45 10.95 16.5 8.325 16.5H5.175C2.55 16.5 1.5 15.45 1.5 12.825V9.675C1.5 7.05 2.55 6 5.175 6H8.325C10.95 6 12 7.05 12 9.675Z"
            fill="currentColor"
          />
          <path
            d="M9.67554 2H12.825C14.0881 2 14.8427 2.25605 15.2937 2.70703C15.7445 3.15803 15.9997 3.91205 15.9998 5.1748V8.3252C15.9997 9.38723 15.8175 10.0906 15.491 10.5527C15.1777 10.996 14.6791 11.2903 13.8679 11.4199C13.6756 11.4506 13.4373 11.287 13.4373 10.9805V9.6748C13.4372 8.03216 13.0565 6.7247 12.1658 5.83398C11.275 4.94334 9.96759 4.5625 8.32495 4.5625H7.01929C6.71307 4.5624 6.54939 4.32499 6.57983 4.13281C6.70939 3.32137 7.00458 2.82213 7.448 2.50879C7.91014 2.18245 8.61378 2 9.67554 2Z"
            fill="currentColor"
            stroke="currentColor"
          />
        </>
      )
    case 'loading':
      return (
        <>
          <path
            opacity="0.6"
            d="M30.4492 18.4502H34.5576C35.5517 18.4502 36.3574 19.2569 36.3574 20.251C36.3572 21.2448 35.5515 22.0508 34.5576 22.0508H30.4492C29.4553 22.0508 28.6486 21.2448 28.6484 20.251C28.6484 19.2569 29.4552 18.4502 30.4492 18.4502Z"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="1.53406"
          />
          <path
            d="M5.94287 18.4502H10.0513C11.0453 18.4502 11.8511 19.2569 11.8511 20.251C11.8509 21.245 11.0452 22.0508 10.0513 22.0508H5.94287C4.94895 22.0508 4.1423 21.2448 4.14209 20.251C4.14209 19.2569 4.94882 18.4502 5.94287 18.4502Z"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="1.53406"
          />
          <path
            d="M20.1934 28.6484C21.1874 28.6486 21.9932 29.4553 21.9932 30.4492V34.5576C21.9932 35.5515 21.1872 36.3582 20.1934 36.3584C19.1993 36.3584 18.3926 35.5517 18.3926 34.5576V30.4492C18.3926 29.4552 19.1993 28.6484 20.1934 28.6484Z"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="1.53406"
          />
          <path
            opacity="0.2"
            d="M20.1928 3.37598C18.7751 3.37598 17.626 4.52548 17.626 5.94315V10.0521C17.626 11.4697 18.7755 12.6189 20.1931 12.6189C21.6108 12.6189 22.76 11.4694 22.76 10.0517V5.9428C22.76 4.52514 21.6106 3.37598 20.1928 3.37598Z"
            fill="currentColor"
          />
          <path
            opacity="0.8"
            d="M29.2767 25.6473C28.2743 24.6449 26.6489 24.6449 25.6464 25.6473C24.6439 26.6496 24.6439 28.275 25.6464 29.2775L28.5519 32.1832C29.0532 32.6844 29.7101 32.9351 30.3671 32.9351C31.0241 32.9351 31.6811 32.6844 32.1822 32.1832C33.1847 31.1808 33.1847 29.5554 32.1822 28.5529L29.2767 25.6473Z"
            fill="currentColor"
          />
          <path
            d="M11.9485 8.31828C10.9461 7.31561 9.32071 7.31595 8.31822 8.31828C7.31572 9.32078 7.31589 10.9462 8.31822 11.9485L11.2239 14.8542C11.7251 15.3556 12.3821 15.6062 13.0389 15.6062C13.6959 15.6062 14.3529 15.3554 14.854 14.8542C15.8565 13.8517 15.8563 12.2264 14.854 11.224L11.9485 8.31828Z"
            fill="currentColor"
          />
          <path
            d="M11.2232 25.6474L8.31758 28.5533C7.31525 29.5558 7.31542 31.1812 8.31775 32.1837C8.81917 32.685 9.47598 32.9355 10.1328 32.9355C10.7898 32.9355 11.4469 32.6848 11.948 32.1837L14.8537 29.2779C15.856 28.2754 15.8558 26.6499 14.8535 25.6474C13.851 24.6448 12.2257 24.6449 11.2232 25.6474Z"
            fill="currentColor"
          />
          <path
            opacity="0.4"
            d="M27.4616 15.6064C28.1185 15.6064 28.7755 15.3557 29.2766 14.8544L32.1823 11.9486C33.1848 10.9461 33.1848 9.32084 32.1823 8.31834C31.1799 7.31567 29.5545 7.31585 28.552 8.31834L25.6463 11.2242C24.6438 12.2267 24.644 13.8521 25.6463 14.8544C26.1476 15.3559 26.8046 15.6064 27.4616 15.6064Z"
            fill="currentColor"
          />
        </>
      )
    case 'campaign':
      return (
        <>
          <path
            d="M3.75 1.875C4.78553 1.875 5.625 2.71447 5.625 3.75C5.625 4.78553 4.78553 5.625 3.75 5.625C2.71447 5.625 1.875 4.78553 1.875 3.75C1.875 2.71447 2.71447 1.875 3.75 1.875Z"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="0.75"
          />
          <path
            d="M14.25 11.25C15.4926 11.25 16.5 10.2426 16.5 9C16.5 7.75736 15.4926 6.75 14.25 6.75C13.0074 6.75 12 7.75736 12 9C12 10.2426 13.0074 11.25 14.25 11.25Z"
            fill="currentColor"
          />
          <path
            d="M3.75 16.5C4.99264 16.5 6 15.4926 6 14.25C6 13.0074 4.99264 12 3.75 12C2.50736 12 1.5 13.0074 1.5 14.25C1.5 15.4926 2.50736 16.5 3.75 16.5Z"
            fill="currentColor"
          />
          <path
            d="M3.75 12.5625C3.4425 12.5625 3.1875 12.3075 3.1875 12V6C3.1875 5.6925 3.4425 5.4375 3.75 5.4375C4.0575 5.4375 4.3125 5.6925 4.3125 6C4.3125 7.6425 5.1075 8.4375 6.75 8.4375H12C12.3075 8.4375 12.5625 8.6925 12.5625 9C12.5625 9.3075 12.3075 9.5625 12 9.5625H6.75C5.73 9.5625 4.9125 9.3 4.3125 8.805V12C4.3125 12.3075 4.0575 12.5625 3.75 12.5625Z"
            fill="currentColor"
          />
        </>
      )
    case 'text':
      return (
        <>
          <path
            d="M15.7125 3.0975C15.495 2.7825 15.2175 2.505 14.9025 2.2875C14.19 1.77 13.26 1.5 12.1425 1.5H5.8575C5.7075 1.5 5.5575 1.5075 5.415 1.5225C2.955 1.68 1.5 3.2775 1.5 5.8575V12.1425C1.5 13.26 1.77 14.19 2.2875 14.9025C2.505 15.2175 2.7825 15.495 3.0975 15.7125C3.7125 16.1625 4.4925 16.425 5.415 16.485C5.5575 16.4925 5.7075 16.5 5.8575 16.5H12.1425C14.8725 16.5 16.5 14.8725 16.5 12.1425V5.8575C16.5 4.74 16.23 3.81 15.7125 3.0975ZM14.0625 6.675C14.0625 6.9825 13.8075 7.2375 13.5 7.2375C13.1925 7.2375 12.9375 6.9825 12.9375 6.675V5.79C12.9375 5.55 12.7425 5.355 12.5025 5.355H9.5625V12.645H10.8975C11.205 12.645 11.46 12.9 11.46 13.2075C11.46 13.515 11.205 13.77 10.8975 13.77H7.1025C6.795 13.77 6.54 13.515 6.54 13.2075C6.54 12.9 6.795 12.645 7.1025 12.645H8.4375V5.355H5.4975C5.2575 5.355 5.0625 5.55 5.0625 5.79V6.675C5.0625 6.9825 4.8075 7.2375 4.5 7.2375C4.1925 7.2375 3.9375 6.9825 3.9375 6.675V5.79C3.9375 4.9275 4.635 4.23 5.4975 4.23H12.495C13.3575 4.23 14.055 4.9275 14.055 5.79V6.675H14.0625Z"
            fill="currentColor"
          />
        </>
      )

    case 'flash':
      return (
        <>
          <path
            d="M13.4324 8.03992H11.1149V2.63992C11.1149 1.37992 10.4324 1.12492 9.59989 2.06992L8.99989 2.75242L3.92239 8.52742C3.22489 9.31492 3.51739 9.95992 4.56739 9.95992H6.88489V15.3599C6.88489 16.6199 7.56739 16.8749 8.39989 15.9299L8.99989 15.2474L14.0774 9.47242C14.7749 8.68492 14.4824 8.03992 13.4324 8.03992Z"
            fill="currentColor"
          />
        </>
      )

    case 'camera':
      return (
        <>
          <path
            d="M13.4999 4.5C13.0424 4.5 12.6224 4.2375 12.4124 3.8325L11.8724 2.745C11.5274 2.0625 10.6274 1.5 9.86238 1.5H8.14488C7.37238 1.5 6.47238 2.0625 6.12738 2.745L5.58738 3.8325C5.37738 4.2375 4.95738 4.5 4.49988 4.5C2.87238 4.5 1.58238 5.8725 1.68738 7.4925L2.07738 13.6875C2.16738 15.2325 2.99988 16.5 5.06988 16.5H12.9299C14.9999 16.5 15.8249 15.2325 15.9224 13.6875L16.3124 7.4925C16.4174 5.8725 15.1274 4.5 13.4999 4.5ZM7.87488 5.4375H10.1249C10.4324 5.4375 10.6874 5.6925 10.6874 6C10.6874 6.3075 10.4324 6.5625 10.1249 6.5625H7.87488C7.56738 6.5625 7.31238 6.3075 7.31238 6C7.31238 5.6925 7.56738 5.4375 7.87488 5.4375ZM8.99988 13.59C7.60488 13.59 6.46488 12.4575 6.46488 11.055C6.46488 9.6525 7.59738 8.52 8.99988 8.52C10.4024 8.52 11.5349 9.6525 11.5349 11.055C11.5349 12.4575 10.3949 13.59 8.99988 13.59Z"
            fill="currentColor"
          />
        </>
      )
    case 'staff':
      return (
        <>
          <path
            d="M16.5 9C16.5 4.8675 13.1325 1.5 9 1.5C4.8675 1.5 1.5 4.8675 1.5 9C1.5 11.175 2.4375 13.1325 3.9225 14.505C3.9225 14.5125 3.9225 14.5125 3.915 14.52C3.99 14.595 4.08 14.655 4.155 14.7225C4.2 14.76 4.2375 14.7975 4.2825 14.8275C4.4175 14.94 4.5675 15.045 4.71 15.15C4.7625 15.1875 4.8075 15.2175 4.86 15.255C5.0025 15.3525 5.1525 15.4425 5.31 15.525C5.3625 15.555 5.4225 15.5925 5.475 15.6225C5.625 15.705 5.7825 15.78 5.9475 15.8475C6.0075 15.8775 6.0675 15.9075 6.1275 15.93C6.2925 15.9975 6.4575 16.0575 6.6225 16.11C6.6825 16.1325 6.7425 16.155 6.8025 16.17C6.9825 16.2225 7.1625 16.2675 7.3425 16.3125C7.395 16.3275 7.4475 16.3425 7.5075 16.35C7.7175 16.395 7.9275 16.425 8.145 16.4475C8.175 16.4475 8.205 16.455 8.235 16.4625C8.49 16.485 8.745 16.5 9 16.5C9.255 16.5 9.51 16.485 9.7575 16.4625C9.7875 16.4625 9.8175 16.455 9.8475 16.4475C10.065 16.425 10.275 16.395 10.485 16.35C10.5375 16.3425 10.59 16.32 10.65 16.3125C10.83 16.2675 11.0175 16.23 11.19 16.17C11.25 16.1475 11.31 16.125 11.37 16.11C11.535 16.05 11.7075 15.9975 11.865 15.93C11.925 15.9075 11.985 15.8775 12.045 15.8475C12.2025 15.78 12.36 15.705 12.5175 15.6225C12.5775 15.5925 12.63 15.555 12.6825 15.525C12.8325 15.435 12.9825 15.3525 13.1325 15.255C13.185 15.225 13.23 15.1875 13.2825 15.15C13.4325 15.045 13.575 14.94 13.71 14.8275C13.755 14.79 13.7925 14.7525 13.8375 14.7225C13.92 14.655 14.0025 14.5875 14.0775 14.52C14.0775 14.5125 14.0775 14.5125 14.07 14.505C15.5625 13.1325 16.5 11.175 16.5 9ZM12.705 12.7275C10.6725 11.3625 7.3425 11.3625 5.295 12.7275C4.965 12.945 4.695 13.2 4.47 13.4775C3.33 12.3225 2.625 10.74 2.625 9C2.625 5.4825 5.4825 2.625 9 2.625C12.5175 2.625 15.375 5.4825 15.375 9C15.375 10.74 14.67 12.3225 13.53 13.4775C13.3125 13.2 13.035 12.945 12.705 12.7275Z"
            fill="currentColor"
          />
          <path
            d="M9 5.19751C7.4475 5.19751 6.1875 6.45751 6.1875 8.01001C6.1875 9.53251 7.38 10.77 8.9625 10.815C8.985 10.815 9.015 10.815 9.03 10.815C9.045 10.815 9.0675 10.815 9.0825 10.815C9.09 10.815 9.0975 10.815 9.0975 10.815C10.6125 10.7625 11.805 9.53251 11.8125 8.01001C11.8125 6.45751 10.5525 5.19751 9 5.19751Z"
            fill="currentColor"
          />
        </>
      )
    case 'import':
      return (
        <>
          <path
            d="M12.6 6.75H9.5625V10.08L11.115 8.5275C11.2275 8.415 11.37 8.3625 11.5125 8.3625C11.655 8.3625 11.7975 8.415 11.91 8.5275C12.1275 8.745 12.1275 9.105 11.91 9.3225L9.3975 11.835C9.18 12.0525 8.82 12.0525 8.6025 11.835L6.09 9.3225C5.8725 9.105 5.8725 8.745 6.09 8.5275C6.3075 8.31 6.6675 8.31 6.885 8.5275L8.4375 10.08V6.75H5.4C3 6.75 1.5 8.25 1.5 10.65V12.5925C1.5 15 3 16.5 5.4 16.5H12.5925C14.9925 16.5 16.4925 15 16.4925 12.6V10.65C16.5 8.25 15 6.75 12.6 6.75Z"
            fill="currentColor"
          />
          <path
            d="M9 1.875C9.10039 1.875 9.1875 1.96211 9.1875 2.0625V6.375H8.8125V2.0625C8.8125 1.96211 8.89961 1.875 9 1.875Z"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="0.75"
          />
        </>
      )
    case 'email-preview':
      return (
        <>
          <path
            d="M14.25 6C15.4926 6 16.5 4.99264 16.5 3.75C16.5 2.50736 15.4926 1.5 14.25 1.5C13.0074 1.5 12 2.50736 12 3.75C12 4.99264 13.0074 6 14.25 6Z"
            fill="currentColor"
          />
          <path
            d="M4.49219 9.90747C5.04549 9.90747 5.54053 10.2153 5.79297 10.7141V10.7131L6.38477 11.8909C6.52034 12.1693 6.71026 12.3482 6.92383 12.4504C7.13032 12.5493 7.33057 12.5627 7.46289 12.5627H9.79492C10.2492 12.5627 10.6648 12.3124 10.8721 11.8997L11.4707 10.7151L11.4717 10.7161C11.7238 10.2239 12.2185 9.9153 12.7725 9.91528H15.2549C15.2839 9.91528 15.3145 9.92701 15.3389 9.95142C15.3632 9.9758 15.375 10.0064 15.375 10.0354V12.761C15.2892 13.8704 14.8988 14.6987 14.2822 15.2522C13.6623 15.8086 12.7717 16.1252 11.6172 16.1252H5.64746C4.4244 16.1252 3.49154 15.7624 2.86523 15.137C2.23913 14.5116 1.87506 13.5791 1.875 12.3528V10.0354C1.875 10.0067 1.88717 9.97568 1.91309 9.94946C1.92633 9.93608 1.94107 9.92523 1.95703 9.91821L2.00586 9.90747H4.49219Z"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="0.75"
          />
          <path
            d="M15.75 7.8V8.4975C15.5925 8.445 15.4275 8.415 15.255 8.415H12.7725C11.6475 8.415 10.635 9.0375 10.14 10.0425L9.615 11.07H7.6425L7.1325 10.05C6.6225 9.0375 5.6175 8.415 4.4925 8.415H1.995C1.8225 8.415 1.6575 8.445 1.5 8.4975V6.39C1.5 4.1025 3.3525 2.25 5.64 2.25H10.2C10.68 2.25 11.025 2.685 10.935 3.15C10.815 3.75 10.8675 4.4025 11.16 5.0925C11.4975 5.8725 12.1275 6.5025 12.9075 6.84C13.5975 7.1325 14.25 7.185 14.85 7.065C15.315 6.975 15.75 7.32 15.75 7.8Z"
            fill="currentColor"
          />
        </>
      )
    case 'eye':
      return (
        <>
          <path
            d="M15.9375 6.86251C14.205 4.14001 11.67 2.57251 9 2.57251C7.665 2.57251 6.3675 2.96251 5.1825 3.69001C3.9975 4.42501 2.9325 5.49751 2.0625 6.86251C1.3125 8.04001 1.3125 9.95251 2.0625 11.13C3.795 13.86 6.33 15.42 9 15.42C10.335 15.42 11.6325 15.03 12.8175 14.3025C14.0025 13.5675 15.0675 12.495 15.9375 11.13C16.6875 9.96001 16.6875 8.04001 15.9375 6.86251ZM9 12.03C7.32 12.03 5.97 10.6725 5.97 9.00001C5.97 7.32751 7.32 5.97001 9 5.97001C10.68 5.97001 12.03 7.32751 12.03 9.00001C12.03 10.6725 10.68 12.03 9 12.03Z"
            fill="currentColor"
          />
          <path
            d="M9.00098 7.35498C9.90209 7.35509 10.6453 8.09843 10.6455 8.99951C10.6455 9.89853 9.90453 10.6371 9.00098 10.6372C8.09962 10.6372 7.36328 9.90087 7.36328 8.99951C7.36353 8.08973 8.10091 7.35498 9.00098 7.35498Z"
            fill="currentColor"
            stroke="currentColor"
          />
        </>
      )
    case 'users-filled':
      return (
        <>
          <path
            d="M6.75 1.5C4.785 1.5 3.1875 3.0975 3.1875 5.0625C3.1875 6.99 4.695 8.55 6.66 8.6175C6.72 8.61 6.78 8.61 6.825 8.6175C6.84 8.6175 6.8475 8.6175 6.8625 8.6175C6.87 8.6175 6.87 8.6175 6.8775 8.6175C8.7975 8.55 10.305 6.99 10.3125 5.0625C10.3125 3.0975 8.715 1.5 6.75 1.5Z"
            fill="#06FF48"
          />
          <path
            d="M10.56 10.6124C8.46747 9.21741 5.05497 9.21741 2.94747 10.6124C1.99497 11.2499 1.46997 12.1124 1.46997 13.0349C1.46997 13.9574 1.99497 14.8124 2.93997 15.4424C3.98997 16.1474 5.36997 16.4999 6.74997 16.4999C8.12997 16.4999 9.50997 16.1474 10.56 15.4424C11.505 14.8049 12.03 13.9499 12.03 13.0199C12.0225 12.0974 11.505 11.2424 10.56 10.6124Z"
            fill="#06FF48"
          />
          <path
            d="M14.9925 5.50507C15.1125 6.96007 14.0775 8.23507 12.645 8.40757C12.6375 8.40757 12.6375 8.40757 12.63 8.40757H12.6075C12.5625 8.40757 12.5175 8.40757 12.48 8.42257C11.7525 8.46007 11.085 8.22757 10.5825 7.80007C11.355 7.11007 11.7975 6.07507 11.7075 4.95007C11.655 4.34257 11.445 3.78757 11.13 3.31507C11.415 3.17257 11.745 3.08257 12.0825 3.05257C13.5525 2.92507 14.865 4.02007 14.9925 5.50507Z"
            fill="#06FF48"
          />
          <path
            d="M16.4926 12.4426C16.4326 13.1701 15.9676 13.8001 15.1876 14.2276C14.4376 14.6401 13.4926 14.8351 12.5551 14.8126C13.0951 14.3251 13.4101 13.7176 13.4701 13.0726C13.5451 12.1426 13.1026 11.2501 12.2176 10.5376C11.7151 10.1401 11.1301 9.82505 10.4926 9.59255C12.1501 9.11255 14.2351 9.43505 15.5176 10.4701C16.2076 11.0251 16.5601 11.7226 16.4926 12.4426Z"
            fill="#06FF48"
          />
        </>
      )
    case 'events-star':
      return (
        <>
          <path
            d="M11.5425 3.90746L12.6 6.02246C12.7425 6.31496 13.125 6.59246 13.4475 6.65246L15.36 6.96746C16.5825 7.16996 16.8675 8.05496 15.99 8.93996L14.4975 10.4325C14.25 10.68 14.1075 11.1675 14.19 11.52L14.6175 13.365C14.955 14.82 14.175 15.39 12.8925 14.625L11.1 13.56C10.7775 13.365 10.2375 13.365 9.91496 13.56L8.12246 14.625C6.83996 15.3825 6.05996 14.82 6.39746 13.365L6.82496 11.52C6.89246 11.16 6.74996 10.6725 6.50246 10.425L5.00996 8.93246C4.13246 8.05496 4.41746 7.16996 5.63996 6.95996L7.55246 6.64496C7.87496 6.59246 8.25746 6.30746 8.39996 6.01496L9.45746 3.89996C10.035 2.75996 10.965 2.75996 11.5425 3.90746Z"
            fill="#06FF48"
          />
          <path
            d="M6 4.3125H1.5C1.1925 4.3125 0.9375 4.0575 0.9375 3.75C0.9375 3.4425 1.1925 3.1875 1.5 3.1875H6C6.3075 3.1875 6.5625 3.4425 6.5625 3.75C6.5625 4.0575 6.3075 4.3125 6 4.3125Z"
            fill="#06FF48"
          />
          <path
            d="M3.75 14.8125H1.5C1.1925 14.8125 0.9375 14.5575 0.9375 14.25C0.9375 13.9425 1.1925 13.6875 1.5 13.6875H3.75C4.0575 13.6875 4.3125 13.9425 4.3125 14.25C4.3125 14.5575 4.0575 14.8125 3.75 14.8125Z"
            fill="#06FF48"
          />
          <path
            d="M2.25 9.5625H1.5C1.1925 9.5625 0.9375 9.3075 0.9375 9C0.9375 8.6925 1.1925 8.4375 1.5 8.4375H2.25C2.5575 8.4375 2.8125 8.6925 2.8125 9C2.8125 9.3075 2.5575 9.5625 2.25 9.5625Z"
            fill="#06FF48"
          />
        </>
      )
    case 'close-circle-outline':
      return (
        <>
          <path
            d="M9 16.5C13.125 16.5 16.5 13.125 16.5 9C16.5 4.875 13.125 1.5 9 1.5C4.875 1.5 1.5 4.875 1.5 9C1.5 13.125 4.875 16.5 9 16.5Z"
            stroke="currentColor"
            strokeWidth="0.75"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.87744 11.1224L11.1224 6.87744"
            stroke="currentColor"
            strokeWidth="0.75"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.1224 11.1224L6.87744 6.87744"
            stroke="currentColor"
            strokeWidth="0.75"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )
    case 'online-check-in':
      return (
        <>
          <path
            d="M11.835 1.5H6.165C3.33 1.5 2.625 2.2575 2.625 5.28V13.725C2.625 15.72 3.72 16.1925 5.0475 14.7675L5.055 14.76C5.67 14.1075 6.6075 14.16 7.14 14.8725L7.8975 15.885C8.505 16.6875 9.4875 16.6875 10.095 15.885L10.8525 14.8725C11.3925 14.1525 12.33 14.1 12.945 14.76C14.28 16.185 15.3675 15.7125 15.3675 13.7175V5.28C15.375 2.2575 14.67 1.5 11.835 1.5ZM11.13 7.4925L10.755 7.875H10.7475L8.475 10.1475C8.3775 10.245 8.175 10.35 8.0325 10.365L7.02 10.515C6.6525 10.5675 6.3975 10.305 6.45 9.945L6.5925 8.925C6.615 8.7825 6.7125 8.5875 6.81 8.4825L9.09 6.21L9.465 5.8275C9.7125 5.58 9.99 5.4 10.29 5.4C10.545 5.4 10.8225 5.52 11.13 5.8275C11.805 6.5025 11.5875 7.035 11.13 7.4925Z"
            fill="#06FF48"
          />
        </>
      )
    case 'barcode-check-in':
      return (
        <>
          <path
            d="M2.0775 7.5C1.755 7.5 1.5 7.245 1.5 6.9225V5.19C1.5 3.1575 3.1575 1.5 5.19 1.5H6.9225C7.245 1.5 7.5 1.755 7.5 2.0775C7.5 2.4 7.245 2.655 6.9225 2.655H5.19C3.7875 2.655 2.655 3.795 2.655 5.19V6.9225C2.655 7.245 2.3925 7.5 2.0775 7.5Z"
            fill="#06FF48"
          />
          <path
            d="M15.9225 7.5C15.6075 7.5 15.345 7.245 15.345 6.9225V5.19C15.345 3.7875 14.205 2.655 12.81 2.655H11.0775C10.755 2.655 10.5 2.3925 10.5 2.0775C10.5 1.7625 10.755 1.5 11.0775 1.5H12.81C14.8425 1.5 16.5 3.1575 16.5 5.19V6.9225C16.5 7.245 16.245 7.5 15.9225 7.5Z"
            fill="#06FF48"
          />
          <path
            d="M12.81 16.5H11.7675C11.4525 16.5 11.19 16.245 11.19 15.9225C11.19 15.6075 11.445 15.345 11.7675 15.345H12.81C14.2125 15.345 15.345 14.205 15.345 12.81V11.775C15.345 11.46 15.6 11.1975 15.9225 11.1975C16.2375 11.1975 16.5 11.4525 16.5 11.775V12.81C16.5 14.8425 14.8425 16.5 12.81 16.5Z"
            fill="#06FF48"
          />
          <path
            d="M6.9225 16.5H5.19C3.1575 16.5 1.5 14.8425 1.5 12.81V11.0775C1.5 10.755 1.755 10.5 2.0775 10.5C2.4 10.5 2.655 10.755 2.655 11.0775V12.81C2.655 14.2125 3.795 15.345 5.19 15.345H6.9225C7.2375 15.345 7.5 15.6 7.5 15.9225C7.5 16.245 7.245 16.5 6.9225 16.5Z"
            fill="#06FF48"
          />
          <path
            d="M13.845 8.42261H12.825H5.175H4.155C3.8325 8.42261 3.5775 8.68511 3.5775 9.00011C3.5775 9.31511 3.8325 9.57761 4.155 9.57761H5.175H12.825H13.845C14.1675 9.57761 14.4225 9.31511 14.4225 9.00011C14.4225 8.68511 14.1675 8.42261 13.845 8.42261Z"
            fill="#06FF48"
          />
          <path
            d="M5.17499 10.4551V10.7026C5.17499 11.9476 6.17999 12.9526 7.42499 12.9526H10.575C11.82 12.9526 12.825 11.9476 12.825 10.7026V10.4551C12.825 10.3651 12.7575 10.2976 12.6675 10.2976H5.33249C5.24249 10.2976 5.17499 10.3651 5.17499 10.4551Z"
            fill="#06FF48"
          />
          <path
            d="M5.17499 7.54511V7.29761C5.17499 6.05261 6.17999 5.04761 7.42499 5.04761H10.575C11.82 5.04761 12.825 6.05261 12.825 7.29761V7.54511C12.825 7.63511 12.7575 7.70261 12.6675 7.70261H5.33249C5.24249 7.70261 5.17499 7.63511 5.17499 7.54511Z"
            fill="#06FF48"
          />
        </>
      )
    case 'transfer-history':
      return (
        <>
          <path
            d="M12.105 2.22003L5.3325 4.47003C0.779996 5.99253 0.779996 8.47503 5.3325 9.99003L7.3425 10.6575L8.01 12.6675C9.525 17.22 12.015 17.22 13.53 12.6675L15.7875 5.90253C16.7925 2.86503 15.1425 1.20753 12.105 2.22003ZM12.345 6.25503L9.495 9.12003C9.3825 9.23253 9.24 9.28503 9.0975 9.28503C8.955 9.28503 8.8125 9.23253 8.7 9.12003C8.4825 8.90253 8.4825 8.54253 8.7 8.32503L11.55 5.46003C11.7675 5.24253 12.1275 5.24253 12.345 5.46003C12.5625 5.67753 12.5625 6.03753 12.345 6.25503Z"
            fill="#06FF48"
          />
        </>
      )
    case 'topup-coin':
      return (
        <>
          <path
            d="M16.44 12.5624C16.1925 14.5574 14.5575 16.1924 12.5625 16.4399C11.355 16.5899 10.23 16.2599 9.35249 15.6149C8.84999 15.2474 8.96999 14.4674 9.56999 14.2874C11.8275 13.6049 13.605 11.8199 14.295 9.56245C14.475 8.96995 15.255 8.84995 15.6225 9.34495C16.26 10.2299 16.59 11.3549 16.44 12.5624Z"
            fill="#06FF48"
          />
          <path
            d="M7.4925 1.5C4.185 1.5 1.5 4.185 1.5 7.4925C1.5 10.8 4.185 13.485 7.4925 13.485C10.8 13.485 13.485 10.8 13.485 7.4925C13.4775 4.185 10.8 1.5 7.4925 1.5ZM6.7875 6.6525L8.595 7.2825C9.2475 7.515 9.5625 7.9725 9.5625 8.6775C9.5625 9.4875 8.9175 10.155 8.13 10.155H8.0625V10.1925C8.0625 10.5 7.8075 10.755 7.5 10.755C7.1925 10.755 6.9375 10.5 6.9375 10.1925V10.1475C6.105 10.11 5.4375 9.4125 5.4375 8.5425C5.4375 8.235 5.6925 7.98 6 7.98C6.3075 7.98 6.5625 8.235 6.5625 8.5425C6.5625 8.8125 6.7575 9.03 6.9975 9.03H8.1225C8.295 9.03 8.43 8.8725 8.43 8.6775C8.43 8.415 8.385 8.4 8.2125 8.34L6.405 7.71C5.76 7.485 5.4375 7.0275 5.4375 6.315C5.4375 5.505 6.0825 4.8375 6.87 4.8375H6.9375V4.8075C6.9375 4.5 7.1925 4.245 7.5 4.245C7.8075 4.245 8.0625 4.5 8.0625 4.8075V4.8525C8.895 4.89 9.5625 5.5875 9.5625 6.4575C9.5625 6.765 9.3075 7.02 9 7.02C8.6925 7.02 8.4375 6.765 8.4375 6.4575C8.4375 6.1875 8.2425 5.97 8.0025 5.97H6.8775C6.705 5.97 6.57 6.1275 6.57 6.3225C6.5625 6.5775 6.6075 6.5925 6.7875 6.6525Z"
            fill="#06FF48"
          />
        </>
      )
  }
}

export interface IIconProps extends React.SVGProps<SVGSVGElement> {
  icon: iconName
  width: string
  height: string
  viewBox: string
  className?: string
  onClick?: () => void
  fill?: string
  opacity?: string
}

export const Icon: FC<IIconProps> = ({
  icon,
  viewBox,
  width,
  height,
  onClick,
  className,
  fill = 'currentColor',
  opacity = '1',
}) => {
  return (
    <StyledIcon
      viewBox={viewBox}
      width={width}
      fill={fill}
      height={height}
      className={className}
      opacity={opacity}
      preserveAspectRatio="xMidYMid meet"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      onClick={() => !!onClick && onClick()}
    >
      {renderIcon(icon)}
    </StyledIcon>
  )
}
